<template>
	<div>

		<Diable10KMMPDialog :ShowModal="Show10KExceedBanner" @okclicked="afterOkHandled">
		</Diable10KMMPDialog>
        <Diable5KDebitCardDialog :ShowModal="Show5KExceedBanner" @okclicked="afterOkDebitCardHandled">
		</Diable5KDebitCardDialog>
		<OnBehalfPopup :vModel="vModel"></OnBehalfPopup>
		<SpecialRateDialog :vModel="vModel"></SpecialRateDialog>
        <PromocodeDialog :vModel="vModel"></PromocodeDialog>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">{{MainHeader}}</h2>
			</div>
		</div>
		<div v-if="vModel.onBehalfDecisionCheck.ShowOnbehalfList" class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />
					<OnBehalfDetail :vModel="vModel"></OnBehalfDetail>
				</div>

			</div>
		</div>
		<div v-else class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />
					<div class="row">
						<div class="col-lg-8">
							<form @submit.prevent="onSubmitOne" novalidate v-if="stepOne" name="stepOneForm">
								<div class="form-card">
									<div class="form-card-header">
										<h3>Transfer Order Details</h3>
									</div>
									<ExchangeCalculator :vModel="vModel" />
									<!-- eo form card forms -->
								</div>
								<!--for sla-->
								<div v-if="vModel.SlaNotifications || vModel.SlaHyperlink" class="form-card">
									<div class="card-body">
										<h3 class="card-title" style="color:#cccccc;">Note:</h3>
										<div v-if="vModel.SlaNotifications">
											<div v-html="vModel.SlaNotifications"></div>
										 <br/>
										</div>
										<div v-if="vModel.SlaHyperlink">
											<p>Click <a target="_blank" :href="vModel.SlaHyperlink" style="color: black;font-weight: bold;"><u>here</u></a> for more information.</p>

										</div>
									</div>
								</div>
								<!-- eo form card -->
								<div class="form-card" v-if="vModel.onBehalfDecisionCheck.ShowOnbehalfSwitch">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<label for="">
													Are you helping someone send money?
												</label>
											</div>
											<div class="col-lg-2">
												<!-- <div class="custom-control custom-switch">
													<input type="checkbox" class="custom-control-input"
														id="isOnBehalfTransaction"
														v-model="vModel.isOnBehalfTransaction"
														name="isOnBehalfTransaction"
														:disabled="vModel.onBehalfDecisionCheck.DisableOnbehalfSwitch">
													<label class="custom-control-label"
														for="isOnBehalfTransaction"></label>
												</div> -->
												 <!-- <div class="custom-control custom-switch">
													<label class="switch">
														<input class="switch-input" type="checkbox"
														id="isOnBehalfTransaction"
															v-model="vModel.isOnBehalfTransaction"
															name="isOnBehalfTransaction"
														/>
														<span class="switch-label" data-on="YES" data-off="NO"></span>
														<span class="switch-handle"></span>
													</label>
												</div> -->
												<!-- <label class="switch switch-text switch-pill switch-primary">
													<input type="checkbox" class="switch-input"
													id="isOnBehalfTransaction"
													v-model="vModel.isOnBehalfTransaction"
													name="isOnBehalfTransaction">
													<span class="switch-label" data-on="Yes" data-off="No"></span>
													<span class="switch-handle"></span>
												</label> -->
												<label class="toggle-switchy" for="isOnBehalfTransaction" data-size="xs" data-style="rounded">
													<input type="checkbox"
													id="isOnBehalfTransaction"
													v-model="vModel.isOnBehalfTransaction"
													name="isOnBehalfTransaction">
													<span class="toggle">
														<span class="switch"></span>
													</span>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.OnBehalfDetail.OnBehalfCustomerId">
											<div class="col-lg-6">
												<div class="onbehalf-name-wrapper">
													<div class="onbehalf-txn-name">
														{{vModel.OnBehalfDetail.Name}}
													</div>
													<div
														class="close-btn" @click="onRemoveOnBehalfCustomer">
														<i class="material-icons">close</i>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<WUPromotion :vModel="vModel" :WuPromotionTypeCollection="WuPromotionTypeCollection"
									v-if="((PayoutModeId == '98' || PayoutModeId == '97') && !IsResend)" />
								<div class="form-card" v-if="!IsResend || (PayoutModeId == '98' || PayoutModeId == '97')">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Purpose of Payment
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="PaymentPurposeId"
														v-model="vModel.PaymentPurposeId"
														data-vv-as="Purpose of Payment" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('PaymentPurposeId') }">
														<option :value="null" disabled>Please Select Purpose of Payment
														</option>
														<!-- <option selected="selected"  class="selectedOption" value="">Please Select Payment Purpose</option> -->
														<option :key="item.Id" v-for="item in PaymentPurposeCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('PaymentPurposeId')" class="help is-danger">
														{{ errors.first('PaymentPurposeId') }}</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->

											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Source of Fund
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="SourceOfFundId"
														v-model="vModel.SourceOfFundId" data-vv-as="Source of fund"
														v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('SourceOfFundId') }">
														<option :value="null" disabled>Please Select Source of Fund
														</option>
														<option :key="item.Id" v-for="item in SourceOfFundsCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('SourceOfFundId')" class="help is-danger">
														{{ errors.first('SourceOfFundId') }}</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
										<!-- eo row -->
										<div class="row">
											<div class="col-lg-6"
												v-if="vModel.SourceOfFundId == 10 && (PayoutModeId == '98' || PayoutModeId == '97')">
												<div class="form-group">
													<label for>
														Source of Fund
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="WUSourceOfFundOtherId"
														v-model="WUSourceOfFundOtherId"
														data-vv-as="Other source of fund" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('WUSourceOfFundOtherId') }"
														@change="handleChangeWuOtherSof">
														<option :value="null" disabled>Please Select</option>
														<!-- <option selected="selected"  class="selectedOption" value="">Please Select Payment Purpose</option> -->
														<option :key="item.Id"
															v-for="item in WUSourceOfFundOtherCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('WUSourceOfFundOtherId')"
														class="help is-danger">
														{{ errors.first('WUSourceOfFundOtherId') }}</div>
												</div>
												<!-- eo form group -->
											</div>

											<!-- eo col -->
											<div class="col-lg-6"
												v-else-if="vModel.RecipientDetail.CountryId == 2 && (vModel.PaymentPurposeId == 10 ||vModel.PaymentPurposeId == 15) && PayoutModeId != '98' && PayoutModeId != '97'">
												<div class="form-group">
													<label for>
														Description of Goods/Services
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<input type="text" class="form-control text-uppercase"
														id="GoodsAndServicesDescription"
														name="GoodsAndServicesDescription" autocomplete="off"
														v-model="vModel.GoodsAndServicesDescription"
														data-vv-as="Description of Goods/Services"
														v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('GoodsAndServicesDescription') }"
														v-only-uppercase />
													<div v-show="errors.has('GoodsAndServicesDescription')"
														class="help is-danger">
														{{ errors.first('GoodsAndServicesDescription') }}
													</div>
													<!-- </div> -->
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
										<!-- eo row -->
										<div class="row">
											<div class="col-lg-6"
												v-if="vModel.SourceOfFundId == 10 && (PayoutModeId == '98' || PayoutModeId == '97')">
												<div class="form-group">
													<label for>
														Source of Fund
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="WUSourceOfFundOtherId"
														v-model="WUSourceOfFundOtherId"
														data-vv-as="Other source of fund" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('WUSourceOfFundOtherId') }"
														@change="handleChangeWuOtherSof">
														<option :value="null" disabled>Please Select</option>
														<!-- <option selected="selected"  class="selectedOption" value="">Please Select Payment Purpose</option> -->
														<option :key="item.Id"
															v-for="item in WUSourceOfFundOtherCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('WUSourceOfFundOtherId')"
														class="help is-danger">
														{{ errors.first('WUSourceOfFundOtherId') }}</div>
												</div>
												<!-- eo form group -->
											</div>

											<!-- eo col -->
											<div class="col-lg-6"
												v-else-if="vModel.SourceOfFundId == 10 && PayoutModeId != '98' && PayoutModeId != '97'">
												<div class="form-group">
													<label for>
														Source of Fund
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<input type="text" class="form-control text-uppercase"
														id="SourceOfFundOthers" name="SourceOfFundOthers"
														autocomplete="off" v-model="vModel.SourceOfFundOthers"
														data-vv-as="Other source of fund"
														v-validate="vModel.SourceOfFundId == 10 ? 'required' : ''"
														:class="{'input': true, 'is-danger': errors.has('SourceOfFundOthers') }"
														v-only-uppercase />
													<div v-show="errors.has('SourceOfFundOthers')"
														class="help is-danger">
														{{ errors.first('SourceOfFundOthers') }}
													</div>
													<!-- </div> -->
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
									</div>
									<!-- eo form card forms -->
								</div>
								<div class="form-card" v-if="IsResend && vModel.ShowGoodsAndServicesOnResend">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Purpose of Payment
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="PaymentPurposeId"
														disabled="true" v-model="vModel.PaymentPurposeId"
														data-vv-as="Purpose of Payment" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('PaymentPurposeId') }">
														<option :value="null" disabled>Please Select Purpose of Payment
														</option>
														<!-- <option selected="selected"  class="selectedOption" value="">Please Select Payment Purpose</option> -->
														<option :key="item.Id" v-for="item in PaymentPurposeCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('PaymentPurposeId')" class="help is-danger">
														{{ errors.first('PaymentPurposeId') }}</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Source of Fund
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="SourceOfFundId"
														disabled="true" v-model="vModel.SourceOfFundId"
														data-vv-as="Source of fund" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('SourceOfFundId') }">
														<option :value="null" disabled>Please Select Source of Fund
														</option>
														<option :key="item.Id" v-for="item in SourceOfFundsCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('SourceOfFundId')" class="help is-danger">
														{{ errors.first('SourceOfFundId') }}</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->

										</div>
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Description of Goods/Services
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<input type="text" class="form-control text-uppercase"
														id="GoodsAndServicesDescription"
														name="GoodsAndServicesDescription" autocomplete="off"
														v-model="vModel.GoodsAndServicesDescription"
														data-vv-as="Description of Goods/Services"
														v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('GoodsAndServicesDescription') }"
														v-only-uppercase />
													<div v-show="errors.has('GoodsAndServicesDescription')"
														class="help is-danger">
														{{ errors.first('GoodsAndServicesDescription') }}
													</div>
													<!-- </div> -->
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->

											<!-- eo col -->
										</div>
										<!-- eo row -->
									</div>

								</div>

								<div class="form-card" v-if="IsResend && vModel.ShowPurposeOfPaymentOnResend">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Purpose of Payment
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="PaymentPurposeId"
														v-model="vModel.PaymentPurposeId"
														data-vv-as="Purpose of Payment" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('PaymentPurposeId') }">
														<option :value="null">Please Select Purpose of Payment
														</option>
														<!-- <option selected="selected"  class="selectedOption" value="">Please Select Payment Purpose</option> -->
														<option :key="item.Id" v-for="item in PaymentPurposeCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('PaymentPurposeId')" class="help is-danger">
														{{ errors.first('PaymentPurposeId') }}</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Source of Fund
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<select class="form-control classic" name="SourceOfFundId"
														disabled="true" v-model="vModel.SourceOfFundId"
														data-vv-as="Source of fund" v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('SourceOfFundId') }">
														<option :value="null" disabled>Please Select Source of Fund
														</option>
														<option :key="item.Id" v-for="item in SourceOfFundsCollection"
															:value="item.Id">{{item.Text}}</option>
													</select>
													<!-- </div> -->

													<div v-show="errors.has('SourceOfFundId')" class="help is-danger">
														{{ errors.first('SourceOfFundId') }}</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
									</div>
								</div>

								<div class="form-card" v-if="vModel.IsSourceOfWealthNeeded">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Source of Wealth
														<span class="required">*</span>
													</label>
													<!-- <div class="input-group mb-3"> -->
													<!-- <select class="form-control classic" id="SourceOfWealthId" name="SourceOfWealthId"
													 v-model="vModel.SourceOfWealthId" v-validate="'required'" data-vv-as="Source of wealth"
													 >
														<option :value="null">Please Select Source of Wealth</option>
														<option  v-for="item in SourceOfWealthCollection" :value="item.Id" :key="item.Id">
															{{item.Text}}
														</option>
                          </select>-->
													<select class="form-control classic"
														v-model="vModel.SourceOfWealthId">
														<option :value="null">Please Select Source of Wealth</option>
														<option v-for="option in SourceOfWealthCollection"
															:key="option.Id" :value="option.Id">{{option.Text}}</option>
													</select>
													<input type="hidden" v-model="vModel.SourceOfWealthId"
														v-validate="'required'" data-vv-as="Source of wealth"
														id="SourceOfWealthId" name="SourceOfWealthId" />

													<div v-show="errors.has('SourceOfWealthId')" class="help is-danger">
														{{ errors.first('SourceOfWealthId') }}</div>
													<!-- </div> -->
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
											<div class="col-lg-6" v-if="vModel.SourceOfWealthId == 11">
												<div class="form-group">
													<label for>
														Source Of Wealth Other
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<input type="text" class="form-control text-uppercase"
															id="SourceOfWealthOthers" name="SourceOfWealthOthers"
															autocomplete="off" v-model="vModel.SourceOfWealthOthers"
															data-vv-as="Other source of wealth" v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('SourceOfWealthOthers') }"
															v-only-uppercase />
														<div v-show="errors.has('SourceOfWealthOthers')"
															class="help is-danger">
															{{ errors.first('SourceOfWealthOthers') }}</div>
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
										<!-- eo row -->
									</div>
									<!-- eo form card forms -->
								</div>

								<div class="form-card" v-if="vModel.IsDocumentRefNoRequired == true">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Document Reference No
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control"
														   id="DocumentRefNo"
														   name="DocumentRefNo" autocomplete="off"
														   v-model="vModel.DocumentRefNo"
														   data-vv-as="Document Reference No"
														   v-validate="'required'"
														   v-only-text-number
														   :class="{'input': true, 'is-danger': errors.has('DocumentRefNo') }"
														   v-only-uppercase />
													<div v-show="errors.has('DocumentRefNo')"
														 class="help is-danger">
														{{ errors.first('DocumentRefNo') }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- eo form card -->
								<!--<div class="form-card" v-if="vModel.IsPaymentReferenceInputAvailable">
									<div class="form-card-forms">

										<div class="form-group">
											<label for="">Reference No</label>
											<div class="row">
												<div class="col-lg-6">
													<div class="input-group">
														<input type="text" class="form-control" id="OrbitPaymentReference" name="OrbitPaymentReference" autocomplete="off" v-model="vModel.OrbitPaymentReference"
														 data-vv-as='Reference No' v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('OrbitPaymentReference') }"
														/>
													</div>
													<div v-show="errors.has('OrbitPaymentReference')" class="help is-danger">
															{{ errors.first('OrbitPaymentReference') }}
														</div>
												</div>

											</div>
										</div>

									</div>
                -->
								<!-- eo form card forms -->
								<!--
                </div>-->
								<!-- eo form card -->

								<div class="form-card" v-if="PayoutModeId != '97' && PayoutModeId != '98' && PayoutModeId != '101' && PayoutModeId != '102' && !IsResend && 1==2">
									<div class="form-card-forms">
										<div class="row" v-if="vModel.IsBonusCardEditable">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>BonusLinkCard Number</label>
													<!-- <div class="input-group mb-3"> -->
													<input type="text" class="form-control text-uppercase"
														name="BonuslinkCardNumber" autocomplete="off"
														v-model="vModel.BonuslinkCardNumber"
														v-validate="'validateBonusLink'"
														:class="{'input': true, 'is-danger': errors.has('BonuslinkCardNumber') }" />
													<div v-show="errors.has('BonuslinkCardNumber')"
														class="help is-danger">
														{{ errors.first('BonuslinkCardNumber') }}
													</div>

													<!-- </div> -->
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->

											<div class="col-lg-6">
												<div class="form-group">
													<label>&nbsp;</label>
													<div class="input-group mb-3">
														<a class="a-with-ul"
															href="http://www.bonuslink.com.my/EN/MemberApplication.aspx"
															target="_blank">
															Register
															Bonus Link
														</a>
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
										<!-- eo row -->
										<div class="row"
											v-if="!vModel.IsBonusCardEditable && vModel.BonuslinkCardNumber != '' && vModel.BonuslinkCardNumber != null">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>BonusLinkCard Number:
														{{vModel.BonuslinkCardNumber}}</label>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
											<div class="col-lg-6">
												<div class="form-group">
													<a class="a-with-ul"
														href="http://www.bonuslink.com.my/EN/MemberApplication.aspx"
														target="_blank">
														Register
														Bonus Link
													</a>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
									</div>
									<!-- eo form card forms -->
								</div>
								<div class="form-card" v-if="vModel.RecipientDetail.CountryId == 220 && !IsResend">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-12">
												<div class="form-group">
													<label for>Test Question:</label>
													<p>
														A test question is required when sending money to South Africa.
														Your receiver will need to know the answer to your question to
														verify their identity.
													</p>
												</div>
												<!-- eo form group -->
											</div>
										</div>
										<div class="row">
											<div class="col-lg-12">
												<div class="form-group">
													<label for>
														Question
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control" id="Question"
														name="Question" autocomplete="off" v-model="vModel.Question"
														data-vv-as="Question" v-validate="'required|max:40'"
														:class="{'input': true, 'is-danger': errors.has('Question') }"
														v-only-uppercase />
													<div v-show="errors.has('Question')" class="help is-danger">
														{{ errors.first('Question') }}</div>
												</div>
												<!-- eo form group -->
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-lg-12">
												<div class="form-group">
													<label for>
														Answer
														<span class="required">*</span>
													</label>

													<input type="text" class="form-control text-uppercase" id="Answer"
														name="Answer" autocomplete="off" v-model="vModel.Answer"
														data-vv-as="Answer" v-validate="'required|max:40'"
														:class="{'input': true, 'is-danger': errors.has('Answer') }"
														v-only-uppercase />
													<div v-show="errors.has('Answer')" class="help is-danger">
														{{ errors.first('Answer') }}</div>
												</div>
												<!-- eo form group -->
											</div>
										</div>
									</div>
								</div>
								<!-- Promocode Region Eremit -->
                <div class="form-card" v-if="PayoutModeId != '98' && PayoutModeId != '97' && !IsResend">
                  <div class="form-card-forms">
                    <div class="row">
                      <div class="col-lg-12">
                        <div v-if="!vModel.IsMtaPromotionCodeSelected" class="input-group mb-3"
                          @click="getPromocodeList">
                          <a href="javascript:void(0)">Do you have a Promo Code?</a>
                        </div>
                        <div v-else>
                          <p style="color:grey">Do you have a Promo Code?</p>
                        </div>
                      </div>
                    </div>
                    <br v-if="vModel.IsMtaPromotionCodeSelected">
                    <div class="row" v-if="vModel.IsMtaPromotionCodeSelected">
                      <div class="col-md-12 pro_code">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="wb_left">
                              <h5>{{vModel.UsedPromocodeDetail.PromoCode}}</h5>
                              <span> <i>Applied</i> </span>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="wb_right" v-if="!vModel.UsedPromocodeDetail.IsFreeServiceCharge">
                              <div class="_price">
                                <span>RM</span>
                                {{ vModel.UsedPromocodeDetail.PromotionDiscount.toFixed(2) }}
                              </div>
                              <div class="doyf">Discount on your fee</div>
                            </div>
                            <div class="wb_right" v-if="vModel.UsedPromocodeDetail.IsFreeServiceCharge">
                              <div class="_price">FREE</div>
                              <div class="doyf">Service Fee</div>
                            </div>
                            <div class="_close_btn" @click="onPromocodeCancel">
                              <a href="javascript:void(0)" class="close_font"></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ----- -->
								<div class="submit-option">
									<div class="left-option">
										<button class="btn submit-lefticon-btn" @click="onCancel">
											<span class="left-icon">
												<i class="material-icons">chevron_left</i>
											</span>
											<span class="btn-content">Cancel</span>
										</button>
									</div>
									<div class="right-option">
										<button class="btn submit-righticon-btn">
											<span class="btn-content">Next</span>
											<span class="right-icon">
												<i class="material-icons">chevron_right</i>
											</span>
										</button>
									</div>
								</div>
							</form>

							<form @submit.prevent="onSubmit" novalidate v-if="!stepOne">
								<div class="alert alert-warning mb-5" v-if="ValidationType == 5">
									<p>{{LimitMessage}}</p>
								</div>

								<div class="form-card">
									<div class="form-card-header">
										<h3>{{PaymentCardHeader}}</h3>
									</div>
									<div class="form-card-forms select-payment" v-if="!IsShowEremitPayMap">
										<b-tabs v-model="tabIndex">
											<b-tab active v-if="IsFpxActive" button-id="tabfpx">
												<!-- :title="titleFPX" -->
												<template v-slot:title>
													<img src="/static/img/fpx_logo.jpg" alt style="height:25px;" />
													Internet Banking
												</template>
												<div class="row">
													<div class="col-lg-6">
														<div class="form-group">
															<label for>Online Payment - FPX Banks</label>
															<!-- <div class="input-group mb-3"> -->
															<select class="form-control" name="FPXBankId"
																v-model="vModel.FPXBankId" data-vv-as="FPX bank"
																v-validate="ActiveTab == 'fpx' ? 'required': ''"
																:class="{'input': true, 'is-danger': errors.has('FPXBankId') }">
																<option value class="selectedOption">
																	Please select
																	bank
																</option>
																<option :key="item.Id" v-for="item in FPXBankCollection"
																	:disabled="!item.IsActive" :value="item.Id">
																	{{item.BankDesc}}</option>
															</select>
															<div v-show="errors.has('FPXBankId')"
																class="help is-danger">
																{{ errors.first('FPXBankId') }}
															</div>
															<!-- </div> -->
														</div>
													</div>
													<!-- eo col -->
												</div>
												<div class="row" v-if="PayoutModeId == '98' || PayoutModeId == '97'">
													<div class="col-md-12">
														<h3>
															<u>PROTECT YOURSELF FROM FRAUD</u>
														</h3>
														<p>
															Only use Western Union to send money to friends and family.
															Never send money to someone you have
															not met in person.
														</p>
														<p>
															Scammers sometimes encourage people to transfer money. Do
															not transfer money to anyone
															who asks you to send them money:
														</p>
														<ul class="fraudMessage">
															<li>For an emergency situation you haven't confirmed.</li>
															<li>For an online purchase.</li>
															<li>For anti-virus protection.</li>
															<li>For a deposit or payment on a rental property.</li>
															<li>To claim lottery or prize winnings.</li>
															<li>To pay taxes.</li>
															<li>For a donation to charity.</li>
															<li>For a mystery shopping assignment.</li>
															<li>For a job opportunity.</li>
															<li>For a credit card or loan fee.</li>
															<li>To resolve an immigration matter.</li>
														</ul>
														<p>
															If you transfer money, the person you're sending it to gets
															the money quickly. After the money is
															paid, Western Union may not be able to give you a refund,
															even if you are the victim of fraud,
															except under limited circumstances.
														</p>
														<p>
															If you believe that you are the victim of fraud, call the
															Western Union fraud hotline at
															1-800-81-6332.
														</p>
														<br />
													</div>
												</div>
												<div class="notice-panel">
													<!-- <div class="left-panel">
															<i class="material-icons">chevron_right</i>
                          </div>-->
													<div class="right-panel">
														<div class="pl-3">
															<div class="round">
																<input name="FpxTermandCondition"
																	id="FpxTermandCondition"
																	v-validate="ActiveTab == 'fpx' ? 'required': ''"
																	type="checkbox" />
																<label for="FpxTermandCondition"></label>
																<span class="pl-4">
																	I agree to Merchantrade Asia's Remit Service
																	<a href="https://www.eremit.com.my/privacy/personal"
																		target="_blank" style="color:#ff0000">
																		Terms and
																		Conditions.
																	</a>
																	and <a href="https://mtradeasia.com/legal/privacy-notice" target="_blank" style="color:#ff0000">Privacy Notice</a>.
																</span>
															</div>
														</div>
														<p class="mt-2" v-if="!vModel.OnBehalfDetail.OnBehalfCustomerId">
															I confirm that I am not sending money on behalf of another
															person.
															<br />
														</p>
														<!-- <div class="help is-danger" v-show="errors.has('FpxTermandCondition')">Please agree to terms and
                            conditions to continue</div>-->
													</div>
												</div>
											</b-tab>
											<b-tab v-if="(PayoutModeId != 97 && PayoutModeId != 98 && IsStagingActive)"
												button-id="tabStaging">
												<!-- :title="titleStaging" -->
												<template v-slot:title>
													<img src="/static/img/eremit.png" alt style="height:25px;" /> Pay
													At Store
												</template>
												<div class="form-group">
													<ERemitPayPaymentReview></ERemitPayPaymentReview>
													<br />
													<div class="notice-panel">
														<div class="right-panel">
															<div class="pl-3">
																<div class="round">
																	<input name="StagingTermsandCondition"
																		id="StagingTermsandCondition"
																		v-validate="ActiveTab == 'Staging' ? 'required': ''"
																		type="checkbox" />
																	<label for="StagingTermsandCondition"></label>
																	<span class="pl-4">
																	I agree to Merchantrade Asia's Remit Service
																	<a href="https://www.eremit.com.my/privacy/personal"
																		target="_blank" style="color:#ff0000">
																		Terms and
																		Conditions.
																	</a>
																	and <a href="https://mtradeasia.com/legal/privacy-notice" target="_blank" style="color:#ff0000">Privacy Notice</a>.
																</span>
																</div>
															</div>
															<p class="mt-2" v-if="!vModel.OnBehalfDetail.OnBehalfCustomerId">
															I confirm that I am not sending money on behalf of another
															person.
															<br />
															</p>
															<!-- <div class="help is-danger" v-show="errors.has('StagingTermsandCondition')">Please agree to terms and
                              conditions to continue</div>-->
														</div>
													</div>
												</div>
											</b-tab>
											<b-tab v-if="IsMMPActive" button-id="tabMMP">
												<!-- :title="titleMMP" -->
												<template v-slot:title>
													<img src="/static/img/mmp.jpg" alt style="height:25px;" />
													Merchantrade Money
												</template>
												<div class="row">
													<div class="col-lg-6">
														<div class="form-group">
															<label for>
																Enter New Phone Number
																<span class="required">*</span>
															</label>
															<div class="input-group">
																<div class="input-group-prepend">
																	<span class="input-group-text">60</span>
																</div>
																<input
																	style="font-size: 25px;height: 43px;"
																	type="text" id="MMPayUserName" name="MMPayUserName"
																	autocomplete="off" v-only-numeric maxlength="10"
																	v-model="vModel.MMPayUserName"
																	data-vv-as="MMPay Username"
																	v-validate="ActiveTab == 'mmp' ? 'required': ''"
																	:class="{'input': true, 'is-danger': errors.has('MMPayUserName') }"
																	class="form-control" />
															</div>
															<div v-show="errors.has('MMPayUserName')"
																class="help is-danger">
																{{ errors.first('MMPayUserName') }}</div>
														</div>
													</div>
													<!-- eo col -->
												</div>
												<div class="row" v-if="PayoutModeId == '98' || PayoutModeId == '97'">
													<div class="col-md-12">
														<h3>
															<u>PROTECT YOURSELF FROM FRAUD</u>
														</h3>
														<p>
															Only use Western Union to send money to friends and family.
															Never send money to someone you have
															not met in person.
														</p>
														<p>
															Scammers sometimes encourage people to transfer money. Do
															not transfer money to anyone
															who asks you to send them money:
														</p>
														<ul class="fraudMessage">
															<li>For an emergency situation you haven't confirmed.</li>
															<li>For an online purchase.</li>
															<li>For anti-virus protection.</li>
															<li>For a deposit or payment on a rental property.</li>
															<li>To claim lottery or prize winnings.</li>
															<li>To pay taxes.</li>
															<li>For a donation to charity.</li>
															<li>For a mystery shopping assignment.</li>
															<li>For a job opportunity.</li>
															<li>For a credit card or loan fee.</li>
															<li>To resolve an immigration matter.</li>
														</ul>
														<p>
															If you transfer money, the person you're sending it to gets
															the money quickly. After the money is
															paid, Western Union may not be able to give you a refund,
															even if you are the victim of fraud,
															except under limited circumstances.
														</p>
														<p>
															If you believe that you are the victim of fraud, call the
															Western Union fraud hotline at
															1-800-81-6332.
														</p>
													</div>
												</div>
												<br />
												<div class="notice-panel">
													<!-- <div class="left-panel">
															<i class="material-icons">chevron_right</i>
                          </div>-->
													<div class="right-panel">
														<div class="pl-3">
															<div class="round">
																<input name="MMPTermandCondition"
																	id="MMPTermandCondition"
																	data-vv-as="Please agree to terms and conditions to continue"
																	v-validate="ActiveTab == 'mmp' ? 'required': ''"
																	type="checkbox" />
																<label for="MMPTermandCondition"></label>
																<span class="pl-4">
																	I agree to Merchantrade Asia's Remit Service
																	<a href="https://www.eremit.com.my/privacy/personal"
																		target="_blank" style="color:#ff0000">
																		Terms and
																		Conditions.
																	</a>
																	and <a href="https://mtradeasia.com/legal/privacy-notice" target="_blank" style="color:#ff0000">Privacy Notice</a>.
																</span>
															</div>
														</div>
														<p class="mt-2" v-if="!vModel.OnBehalfDetail.OnBehalfCustomerId">
															I confirm that I am not sending money on behalf of another
															person.
															<br />
														</p>

														<!-- <div class="help is-danger" v-show="errors.has('MMPTermandCondition')">Please agree to terms and
                            conditions to continue</div>-->
													</div>
												</div>
											</b-tab>
											<b-tab v-if="IsDebitCardActive" button-id="tabipay88">
												<!-- :title="titleFPX" -->
												<template v-slot:title>
													<img src="/static/img/debitcard.svg" alt style="height:25px;" />
													Debit Card
												</template>

														<div class="form-group">
															<label for>Debit Card Details</label>
															<div>


															<div class="add-card rounded-border " @click="confirmSaveDebitCard()">
																<!-- <div class="col-md-1"> -->
																	<i class="rounded-border material-icons">add</i>
																	&nbsp;&nbsp;
																	Please Add Your New Debit Card
																<!-- </div> -->
															</div>
															<br>
															<!-- <div class="input-group mb-3"> -->

																<div v-for="(card, index) in IPAY88DebitCardCollection" :key="card.Id">
																	<div class="debit-card" :class="{scselect: el == card.Id}">
																		<div class="row">
																			<div class="col-md-2">
																				<img src="/static/img/debitcard.svg" alt style="height:35px;" />
																			</div>
																			<div class="col-md-9" @click="selectDebitCard(card.Id)">
																				<p>{{card.BankName}}</p>
																				{{card.CCNo}}
																			</div>
																			<div class="col-md-1">
																				<i class="material-icons" @click="deleteDebitCard(card.Id, index)">delete</i>
																			</div>
																		</div>
																	</div>
																	<br>
																</div>

															<!-- <div v-show="errors.has('FPXBankId')"
																class="help is-danger">
																{{ errors.first('FPXBankId') }}
															</div> -->
															<!-- </div> -->
															</div>
														</div>

													<!-- eo col -->

												<div class="row" v-if="PayoutModeId == '98' || PayoutModeId == '97'">
													<div class="col-md-12">
														<h3>
															<u>PROTECT YOURSELF FROM FRAUD</u>
														</h3>
														<p>
															Only use Western Union to send money to friends and family.
															Never send money to someone you have
															not met in person.
														</p>
														<p>
															Scammers sometimes encourage people to transfer money. Do
															not transfer money to anyone
															who asks you to send them money:
														</p>
														<ul class="fraudMessage">
															<li>For an emergency situation you haven't confirmed.</li>
															<li>For an online purchase.</li>
															<li>For anti-virus protection.</li>
															<li>For a deposit or payment on a rental property.</li>
															<li>To claim lottery or prize winnings.</li>
															<li>To pay taxes.</li>
															<li>For a donation to charity.</li>
															<li>For a mystery shopping assignment.</li>
															<li>For a job opportunity.</li>
															<li>For a credit card or loan fee.</li>
															<li>To resolve an immigration matter.</li>
														</ul>
														<p>
															If you transfer money, the person you're sending it to gets
															the money quickly. After the money is
															paid, Western Union may not be able to give you a refund,
															even if you are the victim of fraud,
															except under limited circumstances.
														</p>
														<p>
															If you believe that you are the victim of fraud, call the
															Western Union fraud hotline at
															1-800-81-6332.
														</p>
														<br />
													</div>
												</div>
												<div class="notice-panel">
													<!-- <div class="left-panel">
															<i class="material-icons">chevron_right</i>
                          </div>-->
													<div class="right-panel">
														<div class="pl-3">
															<div class="round">
																<input name="IPAY88TermandCondition"
																	id="IPAY88TermandCondition"
																	v-validate="ActiveTab == 'ipay88' ? 'required': ''"
																	type="checkbox" ref="agreeTerms" />
																<label for="IPAY88TermandCondition"></label>
																<span class="pl-4">
																	I agree to Merchantrade Asia's Remit Service
																	<a href="https://www.eremit.com.my/privacy/personal"
																		target="_blank" style="color:#ff0000">
																		Terms and
																		Conditions.
																	</a>
																	and <a href="https://mtradeasia.com/legal/privacy-notice" target="_blank" style="color:#ff0000">Privacy Notice</a>.
																</span>
															</div>
														</div>
														<p class="mt-2" v-if="!vModel.OnBehalfDetail.OnBehalfCustomerId">
															I confirm that I am not sending money on behalf of another
															person.
															<br />
														</p>
														<!-- <div class="help is-danger" v-show="errors.has('FpxTermandCondition')">Please agree to terms and
                            conditions to continue</div>-->
													</div>
												</div>
											</b-tab>
										</b-tabs>
									</div>
									<div class="form-card-forms select-payment" v-else>
										<GoogleMapDetail></GoogleMapDetail>
									</div>
									<!-- eo form card forms -->
								</div>
								<!-- eo form card -->

								<div class="submit-option">
									<div class="left-option">
										<button type="button" @click="backToStepOne" class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="material-icons">chevron_left</i>
											</span>
											<span class="btn-content">Cancel</span>
										</button>
									</div>
									<div class="right-option">
										<button class="btn submit-righticon-btn">
											<span
												class="btn-content">{{IsShowEremitPayMap ? 'Confirm Booking' : 'Next'}}</span>
											<span class="right-icon">
												<i class="material-icons">chevron_right</i>
											</span>
										</button>
									</div>
									<div class="right-option"
										v-if="ActiveTab == 'Staging' && IsShowEremitPayMap == false">
										<button type="button" class="btn submit-righticon-btn" @click="showEremitMap">
											<span class="btn-content">Find A Partner</span>
											<span class="right-icon">
												<i class="material-icons">location_on</i>
											</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<!-- eo col-8 -->

						<div class="col-lg-4">
							<div class="sidebar">
								<img src="/static/img/icons/arrow-down-indicator-white.png" alt class="sidebar-arrow" />

								<h3 class="sidebar-header">Transfer Summary</h3>

								<hr />
								<div class="country-detail">
									<img :src="'/static/img/flags/'+vModel.RecipientDetail.FlagCode+'.png'" alt />
									<h4>
										{{vModel.RecipientDetail.FullName}}
										<br />
										<span class="country">{{vModel.RecipientDetail.CountryName}}</span>
									</h4>
								</div>

								<!-- <UserCountrySection/> -->
								<hr />

								<div class="personal-detail">
									<ul>
										<li v-if="PayoutModeId == 101">
											<p>Payment Network :</p>
											<h4>Visa</h4>
										</li>
										<li>
											<p>Payment Mode :</p>
											<h4>{{PayoutModeText}}</h4>
										</li>
										<li v-if="PayoutModeId == 21 && this.vModel.RecipientDetail.CountryId == 56">
											<p>Payout Name :</p>
											<h4>{{vModel.RecipientDetail.AgentName}}</h4>
										</li>
										<li v-if="PayoutModeId == 101 && (vModel.RecipientDetail.VisaCardNumber != null && vModel.RecipientDetail.VisaCardNumber != '')">
											<p>Visa Card Number :</p>
											<h4>
												<img src="/static/img/icons/visa_logo.png" style="width:50px; margin-right:5px;">{{vModel.RecipientDetail.VisaCardNumber}}
											</h4>
										</li>
										<li v-if="PayoutModeId == 1 && (vModel.RecipientDetail.CountryId == 23 ||  vModel.RecipientDetail.CountryId == 251 ||  vModel.RecipientDetail.CountryId == 2 ||  vModel.RecipientDetail.CountryId == 3 ||  vModel.RecipientDetail.CountryId == 5 ||  vModel.RecipientDetail.CountryId == 6 ||  vModel.RecipientDetail.CountryId == 8 ||  vModel.RecipientDetail.CountryId == 9 ||  vModel.RecipientDetail.CountryId == 235 ||  vModel.RecipientDetail.CountryId == 123 ||  vModel.RecipientDetail.CountryId == 114) && vModel.RecipientDetail.ReceiverType">
											<p>
												{{
												 "Receiver Type :"
												}}
											</p>
											<h4>
												{{vModel.RecipientDetail.ReceiverType}}
											</h4>
										</li>
										<li>
											<p>
												{{
                        PayoutModeId == 1 ? "Bank Account Holder Name :" :
						(PayoutModeId == 2) ? "Beneficiary Name :" :
						(PayoutModeId == 27 || PayoutModeId == 30 || PayoutModeId == 31 || PayoutModeId == 32 || PayoutModeId == 33) ? "Wallet Holder Name:" :
						(PayoutModeId == 28 || PayoutModeId == 29) ? "eWallet Holder Name:" :"Beneficiary Name :"
												}}
											</p>
											<h4 style="text-transform: uppercase;">
												{{vModel.RecipientDetail.FullName}}
											</h4>
										</li>
										<li v-if="vModel.OnBehalfDetail.OnBehalfCustomerId">
											<p>Beneficial Owner :</p>
											<h4>{{vModel.OnBehalfDetail.Name}}</h4>
										</li>
										<li v-if="PayoutModeId == 1">
											<p>
												Bank Account Number :
											</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 1">
											<p>Bank Name :</p>
											<h4>{{vModel.RecipientDetail.BankName}}</h4>
										</li>
										<li v-if="PayoutModeId == 24 || PayoutModeId == 26">
											<p>Payment Mode : </p>
											<h4>{{PayoutModeText}}</h4>
										</li>
										<li v-if="PayoutModeId == 24">
											<p>eWallet Type :</p>
											<h4>{{vModel.RecipientDetail.BankName}}</h4>
										</li>
										<li v-if="PayoutModeId == 28 || PayoutModeId == 29">
											<p>eWallet Type :</p>
											<h4>{{vModel.RecipientDetail.WalletType}}</h4>
										</li>

										<li v-if="PayoutModeId == 21">
											<p>Union Pay Card :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 22|| PayoutModeId==31 || PayoutModeId ==32 || PayoutModeId == 33">
											<p>Wallet Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 24 || PayoutModeId==27 || PayoutModeId ==28 || PayoutModeId == 29">
											<p>eWallet Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 23 || this.vModel.PayoutModeId == 23">
											<p>bKash Wallet Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 25 || this.vModel.PayoutModeId == 25">
											<p>Wing Wallet Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 26 || this.vModel.PayoutModeId == 26">
											<p>MCB Wallet Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 30 || this.vModel.PayoutModeId == 30">
											<p>Nagad Wallet Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li v-if="PayoutModeId == 2 || PayoutModeId == 34 || PayoutModeId == 35">
											<p>Agent :</p>
											<h4>{{vModel.RecipientDetail.AgentName}}</h4>
										</li>
										<li v-if="PayoutModeId == 98" v-for="(value, key) in vModel.D2BData">
											<p>{{key}} :</p>
											<h4>{{value}}</h4>
										</li>
									</ul>

									<!-- <ul>
										<li>
											<p>Payment Mode : </p>
											<h4>{{PayoutModeText}}</h4>
										</li>
										<li>
											<p>Bank Account Holder Name :</p>
											<h4>{{vModel.RecipientDetail.FullName}}</h4>
										</li>
										<li>
											<p>Bank Account Number :</p>
											<h4>{{vModel.RecipientDetail.AccountNumber}}</h4>
										</li>
										<li>
											<p>Bank Name :</p>
											<h4>{{vModel.RecipientDetail.BankName}}</h4>
										</li>
                  </ul>-->
								</div>

								<hr />

								<div class="amount-detail">
									<ul>
										<li>
											Transfer Amount (MYR) :
											<span>{{isNaN(vModel.PCurrency)? "0.00" :parseFloat(vModel.PCurrency).toFixed(2)}}</span>
										</li>
										<li>
											Exchange Rate :
											<span>{{vModel.ExchangeRate}}</span>
										</li>
										<li>
											Receive Amount ({{vModel.PayCurrency}}) :
											<span>{{isNaN(vModel.SCurrency)? "0.00" : parseFloat(vModel.SCurrency).toFixed(2)}}</span>
										</li>
										<li>
											Service Charge (MYR) :
											<span>{{vModel.TransferFee}}</span>
										</li>
										<li v-if="vModel.PromotionDiscount > 0">
											Promotion Discount (MYR) :
											<span>-{{vModel.PromotionDiscount}}</span>
										</li>
										<li v-if="vModel.ShowGST">
											GST Charge (MYR) :
											<span>{{vModel.GST}}</span>
										</li>
									</ul>
									<div class="total-detail">
										<p>Total Deposited Amount (MYR) : {{ isNaN(vModel.DepositedAmount) ? "0.00" : vModel.DepositedAmount}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<!-- <b-button id="show-btn" @click="visaModalShow = true">Open Modal</b-button> -->

						<b-modal id="crossCountryModal" v-model="visaModalShow" :no-close-on-backdrop="true" hide-footer>
							<template #modal-header	 >
								{{visaModalTitle}}
							</template>
							<div class="d-block">
								<div class="row">
									<div class="col-md-1"></div>
									<div class="col-md-10">
										<b>1 MYR : {{vModel.ExchangeRate}} {{VisaDestinationCurrency}}</b> <br>
										<b>{{parseFloat(vModel.PCurrency).toFixed(2)}} MYR : {{parseFloat(vModel.SCurrency).toFixed(2)}} {{VisaDestinationCurrency}}</b> <br>
										<b>Fee: {{vModel.TransferFee}} MYR </b><br>
										<b> Total Payable : {{vModel.DepositedAmount}} MYR</b> <br>
									</div>
									<div class="col-md-1"></div>
								</div>
							</div>
							<div class="row">
								<div class="mt-3 col-6"></div>
								<b-button variant="primary" class="mt-3 col-6" @click="ShowVisaPopUpEdit()"> Edit Amount </b-button>
							</div>
							<div class="row">
								<b-button class="mt-3 col-6" variant="light"  @click="OnVisaCancel()">No</b-button>
								<b-button class="mt-3 col-6" variant="danger" @click="SaveVisaBeneAndSubmitOne()">Yes</b-button>
							</div>
						</b-modal>

						<b-modal v-model="editVisaModalShow" id="editVisaAmountModal" size="lg" :no-close-on-backdrop="true" hide-footer>
								<template #modal-header>
									<div class="editTitle">
										<strong>Edit Amount</strong><br>
										<p>How much would you like to send?</p>
									</div>
								</template>
								<div class="web-application">
									<ExchangeCalculator :vModel="vModel" :visaCountry="true"/>
								</div>
								<!-- eo form card forms -->
							<b-button class="mt-3 col-6" variant="light"  @click="OnVisaCancel()">Cancel</b-button>

							<b-button class="mt-3 col-6" variant="danger" @click="SaveVisaBeneAndSubmitOne()">Confirm</b-button>
						</b-modal>
						<b-modal v-model="errorVisaModal" id="errorVisaModal" :no-close-on-backdrop="true" hide-footer>
								<template #modal-header>
								{{vModel.Message}}
								</template>
								<!-- eo form card forms -->
							<b-button class="mt-3 col-12" variant="danger" @click="OnVisaCancel()">OK</b-button>
						</b-modal>
						<b-modal id="crossCountryModal" v-model="errorVisaCountryModalShow" :no-close-on-backdrop="true" hide-footer>
							<template #modal-header	 >
								{{visaModalTitle}}
							</template>
							<div class="d-block">
								<strong>Unfortunately we do not support remittance to the below country at the moment.</strong>
								<div class="row">
									<div class="col-md-1"></div>
									<div class="col-md-10">
										<br> <br>
										<b>Selected Counry : {{this.vModel.RecipientDetail.CountryName}}</b> <br>
										<b>Card Issued Country : {{this.vModel.VisaCardIssuerCountry}}</b>
									</div>
									<div class="col-md-1"></div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3"></div>
								<b-button class="mt-3 col-md-6" variant="danger" @click="OnVisaCancel()">Cancel</b-button>
								<div class="col-md-3"></div>
							</div>
						</b-modal>
					</div>
					<!-- eo row -->
					<div class="hidden fpxWrapper" ref="fpxWrapper"></div>
					<div class="hidden ipay88Wrapper" ref="ipay88Wrapper"></div>
					<div class="hidden visaDirectWrapper" ref="visaDirectWrapper"></div>
				</div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>

</template>
<script>
	import Vue from "vue";
	import Base from "../../shared/Base.vue";
	import UserCountrySection from "../../shared/UserCountrySection.vue";
	import $window from "../../main.js";
	import ListService from "../../services/list";
	import ExchangeCalculator from "./exchangeCalculator";
	import WUPromotion from "./wuPromotionSection";
	import TransactionService from "../../services/transaction";
	import commonService from "../../services/common";
	import ERemitPayPaymentReview from "./eRemitPayPaymentReview";
	import GoogleMapDetail from "./partnermap";
	import Diable10KMMPDialog from "../../shared/Diable10KMMPDialog.vue";
	import OnBehalfDetail from "../../shared/OnBehalfDetail.vue";
	import OnBehalfPopup from "../../shared/OnBehalfPopup.vue"
    import SpecialRateDialog from "../../shared/SpecialRateDialog.vue";
    import PromocodeDialog from "../../shared/PromocodeDialog.vue";
    import DisableButtonDialogVue from '../../shared/DisableButtonDialog.vue';
    import Diable5KDebitCardDialog from "../../shared/Diable5KDebitCardDialog.vue";


	export default {
		name: "Moneygram",
		extends: Base,
		components: {
			UserCountrySection,
			ExchangeCalculator,
			WUPromotion,
			ERemitPayPaymentReview,
			GoogleMapDetail,
			Diable10KMMPDialog,
			OnBehalfDetail,
			OnBehalfPopup,
			SpecialRateDialog,
            PromocodeDialog,
			Diable5KDebitCardDialog
		},
		created() {
			this.url.add = "transacton/createweb";
			this.url.edit = "recipient/moneygram/edit";
			this.url.update = "transacton/createweb";
			this.url.submitnoOTP = "payment/mmoney/submittransaction";
		},
		mounted() {
			setTimeout(() => {
				if(this.$route.params.status != undefined){
					this.vModel.RequestIdentifier =commonService.getStorage("RequestIdentifier");
				}
				if(this.$route.params.status == undefined){
					if (this.vModel.OnBehalfTxnProcessGuardList.length > 0) {
					let priority1 = this.vModel.OnBehalfTxnProcessGuardList.filter(x => {
						return x.Priority == 1
					})[0];
					let priority2 = this.vModel.OnBehalfTxnProcessGuardList.filter(x => {
						return x.Priority == 2
					})[0];
					let priority3 = this.vModel.OnBehalfTxnProcessGuardList.filter(x => {
						return x.Priority == 3
					})[0];

					if (priority1.Value) {

						this.vModel.onBehalfDecisionCheck.ShowOnbehalfSwitch = true;

						if (priority2.Value) {
							this.vModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
							this.vModel.onBehalfDecisionCheck.DisableOnbehalfSwitch = true;
							setTimeout(() => {
								kendo.alert("3rd party relationship selected. Please provide On Behalf details to proceed.");
							}, 100);
						}
						else if (!priority2.Value && priority3.Value) {
							this.vModel.onBehalfDecisionCheck.ShowOnbehalfNationalityPopup = true;
						}
					}

					}
				}

				if (this.vModel.TransactionRefNo && this.vModel.PayoutModeId != 97 && this.vModel.PayoutModeId != 98 && this.vModel.PayoutModeId != 101 && this.vModel.PayoutModeId != 102) {
					console.log("txn:" + this.vModel.TransactionRefNo, "paymode:", this.vModel.PayoutModeId);
					TransactionService.getSpecialRateDetail({
						RecipientId: this.vModel.RecipientDetail.Id,
						PaymentModeId: this.vModel.PayoutModeId,
						SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
						RequestIdentifier: this.vModel.RequestIdentifier,
					}).then((res) => {
						if (res.body && res.body.SpecialRateId) {
					this.vModel.SpecialRateDetail.SpecialRateId = res.body.SpecialRateId;
					this.vModel.SpecialRateDetail.SendAmount = res.body.SendAmount.toFixed(2);
					this.vModel.SpecialRateDetail.PayAmount = res.body.PayAmount.toFixed(2);
					this.vModel.SpecialRateDetail.SpecialRate = res.body.SpecialRate.toFixed(4);
					this.vModel.SpecialRateDetail.DefaultRate = res.body.DefaultRate.toFixed(4);
					this.vModel.SpecialRateDetail.CurrencyCode = res.body.CurrencyCode;
					this.vModel.ShowSpecialRateDialog = true;
					}

				});
				}

				//set filtered value from dashboard
				this.CarryModel  = commonService.getStorage("carryModel");
				commonService.removeStorage("carryModel");

				if(this.CarryModel.IsStepOne){
					if(this.CarryModel.SendAmount != 0 && this.CarryModel.PayAmount != 0){
						this.vModel.InitialExchangeRate = this.CarryModel.ExchangeRate
						this.vModel.PCurrency = this.CarryModel.SendAmount;
						this.vModel.SCurrency = this.CarryModel.PayAmount;
						if(this.vModel.PayoutModeId != 97 && this.vModel.PayoutModeId != 98 && this.vModel.PayoutModeId != 101 && this.vModel.PayoutModeId != 102){
							TransactionService.getSpecialRateDetail({
								RecipientId: this.vModel.RecipientDetail.Id,
								PaymentModeId: this.vModel.PayoutModeId,
								SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
								RequestIdentifier: this.vModel.RequestIdentifier,
							}).then((res) => {
								if (res.body && res.body.SpecialRateId) {
									this.vModel.SpecialRateDetail.SpecialRateId = res.body.SpecialRateId;
									this.vModel.SpecialRateDetail.SendAmount = res.body.SendAmount.toFixed(2);
									this.vModel.SpecialRateDetail.PayAmount = res.body.PayAmount.toFixed(2);
									this.vModel.SpecialRateDetail.SpecialRate = res.body.SpecialRate.toFixed(4);
									this.vModel.SpecialRateDetail.DefaultRate = res.body.DefaultRate.toFixed(4);
									this.vModel.SpecialRateDetail.CurrencyCode = res.body.CurrencyCode;
									this.vModel.ShowSpecialRateDialog = true;
								}
							});
						}

					this.vModel.IsLocalCurrencyKeyedIn = this.CarryModel.IsLocalCurrencyKeyIn;

					}


					// if(self.vModel.IsLocalCurrencyKeyedIn){
					// 	this.$children.find( x => x.$options.name == "ExchangeCalculator").onPAmountChange();
					// }else{
					// }
				}

			}, 200);
			if(this.$route.params.status != undefined){
				this.visaStatus = this.$route.params.status;
				this.PayoutModeId = this.$route.params.payoutmodeid;
				var inquiryId = this.$route.params.inquiryorderid;
				this.SetVisaDirectState();
				this.$http.post("transaction/visadirect/txndetail",
					{
						InquiryOrderId : inquiryId,
						RequestIdentifier : this.vModel.RequestIdentifier,
						IsLocalCurrencyKeyIn: this.vModel.IsLocalCurrencyKeyedIn,
						SendAmount : parseFloat(this.vModel.PCurrency).toFixed(2),
						PayoutAmount : parseFloat(this.vModel.SCurrency).toFixed(2)
					}
				).then(
						res => {
							var visaRes = res.body;
							this.VisaDestinationCurrency = visaRes.VisaDestinationCurrency;
							this.vModel.VisaCardIssuerCountry = visaRes.CardIssuerCountry;
							this.vModel.ExchangeRate = visaRes.ExchangeRate;
							this.vModel.OrderReference = visaRes.OrderReference;
							this.vModel.VisaCardNumber = visaRes.VisaCardNumber;
							this.vModel.InquiryOrderId = this.$route.params.inquiryorderid;
							this.vModel.RecipientDetail.CountryId = visaRes.VisaDestinationCountryId;
							this.VisaDestinationCurrencyId = visaRes.VisaDestinationCurrencyId;
							this.vModel.RecipientDetail.FlagCode = visaRes.VisaFlagCode;
							this.vModel.PayCurrency = visaRes.VisaDestinationCurrency;
							this.IsExchangeRateMismatch = visaRes.IsExchangeRateMismatch;
							this.IsNotEremitCountry = visaRes.IsNotEremitCountry;
							this.vModel.RecipientDetail.CountryName = this.IsNotEremitCountry ? this.vModel.RecipientDetail.CountryName : visaRes.VisaDestinationCountry;
							this.vModel.SCurrency = visaRes.PayoutAmount;
							this.vModel.PCurrency = visaRes.SendAmount;
							this.vModel.Message = visaRes.Message;
							if(this.visaStatus == "00"){	//Success
								this.stepOne = false;
								 if(this.IsExchangeRateMismatch){
									this.visaModalTitle = "The rate has been recently updated. Would you like to proceed with the rate below?";
									this.visaModalShow = true;
									this.stepOne = true;
								}else{
									this.stepOne = false;
								}
							}else if(this.visaStatus == "01"){	//Currency Mismatch
								this.stepOne = true;
								this.IsVisaCrossCountry = true;
								if(this.IsNotEremitCountry){
									this.visaModalTitle = "Selected country and receiver card issued country does not match.";
									this.errorVisaCountryModalShow = true;
								}else{
									this.visaModalTitle = "Selected Country and receivers card issued does not match. Would you like to Change to the details below to proceed?";
									this.visaModalShow = true;
								}
							}else{
								this.stepOne = true;
								this.errorVisaModal = true;
							}
						}
					);
				this.ClearVisaStorage();
			}


		},
		beforeRouteEnter(to, from, next) {
				if(to.params.status != undefined && commonService.getStorage("visaModel") == ''){
					next("transaction/" + commonService.getStorage("visaBeneficiaryId") + "/101")
				}
				var promises = [];
				if(to.params.status != undefined){
					promises.push(
						TransactionService.initTransaction({
							beneficiaryId: to.params.status == undefined ? to.params.beneficiaryid : commonService.getStorage("visaBeneficiaryId"),
							PayoutModeId: to.params.payoutmodeid,
							IsRedirect: true
						})
					);
				}else if (to.params.transactionrefno == undefined) {
					promises.push(
						TransactionService.initTransaction({
							beneficiaryId: to.params.status == undefined ? to.params.beneficiaryid : commonService.getStorage("visaBeneficiaryId"),
							payoutmodeid: to.params.payoutmodeid
						})
					);
				} else {
					promises.push(
						TransactionService.initTransaction({
							BeneficiaryId: to.params.beneficiaryid,
							PayoutModeId: to.params.payoutmodeid,
							TransactionRefNo: to.params.transactionrefno,
							IsResend: true
						})
					);
				}

				promises.push(
					ListService.get("payment/providers"),
					ListService.get("v2/transaction/paymentmethod/get"),
					ListService.getOnBehalfList(to.params.payoutmodeid),
					ListService.get("payment/debitcards")
				);
				if(to.params.status == undefined){
					commonService.setStorage("transactionRefNo", "");
				}

				Promise.all(promises).then(response => {
					next(p => {
						var res = response[0].body;
						p.PayoutModeText = res.PayoutModeText;
						p.BeneficiaryId = res.BeneficiaryId;
						p.vModel.ExchangeRate =
							to.params.payoutmodeid == 97 || to.params.payoutmodeid == 98 || to.params.payoutmodeid == 101 || to.params.payoutmodeid == 102
								? res.ExchangeRate
								: res.ExchangeRate.toFixed(4);
						p.vModel.InitialExchangeRate = p.vModel.ExchangeRate;
						p.vModel.PayCurrency = res.PayCurrency;
						p.vModel.Note = res.Note;
						p.vModel.Fee = res.Fee;
						p.vModel.CCDLimit = res.CCDLimit;
						p.vModel.MaxLimit = res.MaxLimit;
						p.vModel.CountryId = res.CountryId;
						p.vModel.SlaNotifications = res.SlaNotification;
						p.vModel.SlaHyperlink = res.SlaHyperlink;
						p.vModel.FreeTransactionCount = res.FreeTransactionCount;
						p.vModel.PromotionCode = res.PromotionCode;
						p.vModel.MoneyGramIndicativeCountry = res.MoneyGramIndicativeCountry;
						p.vModel.IsInMSSL = res.IsInMSSL;
						p.vModel.IsNegative = res.IsNegative;
						p.vModel.IsHRI = res.IsHRI;
						p.vModel.IsHRC = res.IsHRC;
						p.vModel.IsPEPS = res.IsPEPS;
						p.vModel.IsPaymentReferenceInputAvailable =
							res.IsPaymentReferenceInputAvailable;

						p.vModel.RecipientDetail.Id = res.RecipientDetail.Id;
						p.vModel.RecipientDetail.CountryId = res.RecipientDetail.CountryId;
						p.vModel.RecipientDetail.CountryName = res.RecipientDetail.CountryName;
						p.vModel.RecipientDetail.FullName = res.RecipientDetail.FullName;
						p.vModel.RecipientDetail.FlagCode = res.RecipientDetail.FlagCode;
						p.vModel.RecipientDetail.CountryCode3 =
							res.RecipientDetail.CountryCode3;
						p.vModel.RecipientDetail.Street = res.RecipientDetail.Street;
						p.vModel.RecipientDetail.City = res.RecipientDetail.City;
						p.vModel.RecipientDetail.PostalCode = res.RecipientDetail.PostalCode;

						p.vModel.RecipientDetail.Address = res.RecipientDetail.Address;
						p.vModel.RecipientDetail.StateName = res.RecipientDetail.zzName;
						p.vModel.RecipientDetail.MobileContact =
							res.RecipientDetail.MobileContact;
						p.vModel.RecipientDetail.RelationshipId =
							res.RecipientDetail.RelationshipId;

						p.vModel.RecipientDetail.BankName = res.RecipientDetail.BankName;
						p.vModel.RecipientDetail.BranchName = res.RecipientDetail.BranchName;
						p.vModel.RecipientDetail.AgentName = res.RecipientDetail.AgentName;
						p.vModel.RecipientDetail.AgentRemark = res.RecipientDetail.AgentRemark;
						p.vModel.RecipientDetail.WalletType = res.RecipientDetail.WalletType;
						p.vModel.RecipientDetail.AccountNumber =
							res.RecipientDetail.AccountNumber;
						p.vModel.RecipientDetail.RelationshipText =
							res.RecipientDetail.RelationshipText;
						p.vModel.RecipientDetail.VisaCardNumber =res.RecipientDetail.VisaCardNumber;
						p.vModel.FlagCode = res.FlagCode;
						p.vModel.BonuslinkCardNumber = res.BonusCardLink;
						p.vModel.IsSourceOfWealthNeeded = res.IsSourceOfWealthNeeded;
						p.vModel.IsBonusCardEditable = res.IsBonusCardEditable;
						p.vModel.D2BData = res.D2BData;
						p.vModel.WUNumber = res.WUNumber;
						p.vModel.RequestIdentifier = res.RequestIdentifier;
						p.vModel.IsDocumentRefNoRequired = res.IsDocumentRefNoRequired;
						p.vModel.RecipientDetail.ReceiverType = res.RecipientDetail.ReceiverType;
						if (!p.vModel.WUNumber) {
							p.WuPromotionTypeCollection = [] = [
								{
									Id: 1,
									Text: "Marketing Promotion"
								}
							];
						}
						p.vModel.PromotionDetails = res.PromotionDetails;
						p.vModel.GalacticId = res.GalacticId;
						p.PayoutModeId = to.params.payoutmodeid;
						p.vModel.PayoutModeId = to.params.payoutmodeid;
						p.isInit = false;

						var fpxBanks = response[1].body;
						p.PaymentMethodCollection = response[2].body;
						p.vModel.OnBehalfList = response[3].body;
						p.IsFpxActive = p.PaymentMethodCollection.filter(x => {
							return x.Id == 1;
						})[0].IsActive;

						p.IsMMPActive = p.PaymentMethodCollection.filter(x => {
							return x.Id == 2;
						})[0].IsActive;

						p.IsStagingActive = p.PaymentMethodCollection.filter(x => {
							return x.Id == 4;
						})[0].IsActive;

						p.IsDebitCardActive = p.PaymentMethodCollection.filter(x => {
							return x.Id == 6;
						})[0].IsActive;

						p.PaymentPurposeCollection = res.PayPurposes;
						p.SourceOfFundsCollection = res.SourceOfFunds;
						p.SourceOfWealthCollection = res.SourceOfWealths;

						p.FPXBankCollection = fpxBanks.Individual;
						p.vModel.OnBehalfTxnProcessGuardList = res.OnBehalfTxnProcessGuardList;

						var ipay88DebitCards = response[4].body;
						p.IPAY88DebitCardCollection = ipay88DebitCards.Individual;
						p.NoOfCardPerCustomer = ipay88DebitCards.NoOfCardPerCustomer;
						if (to.params.transactionrefno != undefined) {
							commonService.setStorage(
								"transactionRefNo",
								to.params.transactionrefno
							);
							p.vModel.ExchangeRate =
								to.params.payoutmodeid == 97 || to.params.payoutmodeid == 98 || to.params.payoutmodeid == 101 || to.params.payoutmodeid == 102
									? res.AmountCurrencyInfoResend.ExchangeRate
									: res.AmountCurrencyInfoResend.ExchangeRate.toFixed(4);
							p.vModel.InitialExchangeRate = p.vModel.ExchangeRate;
							p.vModel.PCurrency = res.AmountCurrencyInfoResend.SendAmount.toFixed(
								2
							);
							p.vModel.SCurrency = res.AmountCurrencyInfoResend.PayAmount.toFixed(
								2
							);
							p.vModel.TransferFee = res.AmountCurrencyInfoResend.TransferFee.toFixed(
								2
							);
							p.Fee = res.AmountCurrencyInfoResend.TransferFee.toFixed(2);
							p.IsResend = true;
							p.vModel.RequestIdentifier =
								res.AmountCurrencyInfoResend.RequestIdentifier;
							p.vModel.SourceOfFundId = res.SourceOfFundId;
							p.vModel.PaymentPurposeId = res.PaymentPurposeId;
							p.vModel.GoodsAndServicesDescription = res.GoodsAndServicesDescription;
							p.vModel.ShowGoodsAndServicesOnResend = res.ShowGoodsAndServicesOnResend;
							p.vModel.SourceOfWealthId = res.SourceOfWealthId;
							p.vModel.SourceOfWealthOthers = res.SourceOfWealthOthers;
							p.vModel.Question = res.Question;
							p.vModel.Answer = res.Answer;
							p.vModel.DepositedAmount = (
								parseFloat(res.AmountCurrencyInfoResend.SendAmount) +
								parseFloat(res.AmountCurrencyInfoResend.TransferFee)
							).toFixed(2);
							p.vModel.IsLocalCurrencyKeyedIn = true;
							p.vModel.TransactionRefNo = to.params.transactionrefno;
							p.vModel.ShowPurposeOfPaymentOnResend = res.ShowPurposeOfPaymentOnResend;
						}
					});
				});

		},
		data() {
			return {
				visaStatus: "",
				titleFPX:
					'<img src="/static/img/fpx_logo.jpg" alt="" style="height:25px;"/> Internet Banking',
				titleMMP:
					'<img src="/static/img/mmp.jpg" alt="" style="height:25px;"/> Merchantrade Money',
				titleStaging:
					'<img src="/static/img/eremit.png" alt="" style="height:25px;"/> Pay At Store',
				showStagingTab: true,
				stepOne: true,
				isInit: true,
				isStepOneValid: false,
				onProgress: false,
				tabIndex: 0,
				ValidationType: null,
				LimitMessage: null,
				vModel: {
					Id: null,
					PCurrency: undefined,
					FlagCode: null,
					SCurrency: undefined,
					PaymentPurposeId: null,
					SourceOfFundId: null,
					SourceOfWealthId: null,
					ReasonOfRemittanceOthers: null,
					InitialExchangeRate: "",
					ExchangeRate: "",
					ExchangeRateSpecial: "",
					SpecialRateAvailable: false,
					SourceOfWealthOthers: "",
					SourceOfFundOthers: "",
					OrbitPaymentReference: "",
					GST: "",
					GSTPercentage: "",
					ShowGST: false,
					DepositedAmount: "0.00",
					TransferFee: "0.00",
					FPXAmount: "",
					BeneficiaryId: null,
					PayoutModeId: null,
					SourceOfWealths: null,
					IsSourceOfWealthNeeded: false,
					ExchangeRate: null,
					PayCurrency: null,
					SendCurrency: null,
					FPXBankId: "",
					DebitCardId: null,
					IsIPAY88DebitCardSave: false,
					MMPayUserName: null,
					BonuslinkCardNumber: null,
					Question: null,
					Answer: null,
					RecipientDetail: {
						Id: 0,
						CountryId: 3,
						CountryName: null,
						FullName: null,
						FlagCode: null,
						CountryCode3: null,
						Street: "",
						City: "",
						PostalCode: null,
						Address: null,
						StateName: null,
						MobileContact: null,
						RelationshipId: null,
						BankName: null,
						BranchName: null,
						AgentName: null,
						AgentRemark: null,
						AccountNumber: null,
						RelationshipText: null,
						VisaCardNumber: null,
						ReceiverType: null,
						WalletType :null
					  },
					  SpecialRateDetail: {
						SpecialRateId: null,
						SendAmount: null,
						PayAmount: null,
						SpecialRate: null,
						DefaultRate: null,
						CurrencyCode: null,
					  },
					  DefaultRate: null,
					  ShowSpecialRateDialog: false,
					  LastSpecialRateDialogClickedButton: null, //YES/NO
					  SpecialRateId: null,
					  PromocodeDetailList: [],
					  ShowPromocodeDialog: false,
					  IsMtaPromotionCodeSelected: false,
					  SearchedPromocode: null,
					  UsedPromocodeDetail: {
						PromotionCodeId: null,
						PromotionDiscount: null,
						IsFreeServiceCharge: null,
						ValidityDateFrom: null,
						PromoCode: null,
						TotalPromocodesAvailable: null,
						TotalPromocodesUsed: null,
						ValidityDateTo: null
					},
					Note: null,
					Fee: null,
					CCDLimit: null,
					MaxLimit: null,
					CountryId: null,
					SlaNotifications: null,
					SlaHyperlink: null,
					FreeTransactionCount: null,
					PromotionCode: null,
					PromotionDiscount: null,
					MoneyGramIndicativeCountry: false,
					IsInMSSL: false,
					IsNegative: false,
					IsHRI: false,
					IsHRC: false,
					IsPEPS: false,
					IsPaymentReferenceInputAvailable: false,
					IsBonusCardEditable: false,
					WUPromotionType: null,
					WUMarketingPromotionCode: null,
					PromotionDetails: {},
					GalacticId: null,
					IsLocalCurrencyKeyedIn: false,
					D2BData: {},
					IsPromoCodeUsed: false,
					WUNumber: null,
					LoyalPoints: null,
					RequestIdentifier: null,
					ProcessId: null,
					GoodsAndServicesDescription: null,
					ShowGoodsAndServicesOnResend: false,
					ShowPurposeOfPaymentOnResend: false,
					TransactionRefNo: null,
					//ONBEHALF_RELATED
					OnBehalfTxnProcessGuardList: [],
					onBehalfDecisionCheck: {
						ShowOnbehalfSwitch: false,
						DisableOnbehalfSwitch: false,
						ShowOnbehalfList: false,
						ShowOnbehalfNationalityPopup: false,
					},
					OnBehalfList: [],
					OnBehalfDetail: {
						OnBehalfCustomerId: null,
						Name: null,
						IdNumber: null
					},
					isOnBehalfTransaction: false,
					isFromTransaction: true,
					OrderReference:null,
					InquiryOrderId: null,
					DocumentRefNo: null,
					IsDocumentRefNoRequired: false
				},
				PayoutModeId: "",
				PayoutModeText: "",
				BeneficiaryId: "",
				PaymentPurposeCollection: null,
				SourceOfFundsCollection: null,
				SourceOfWealthCollection: [],
				FPXBankCollection: null,
				IPAY88DebitCardCollection: null,
				NoOfCardPerCustomer : null,
				PaymentMethodCollection: null,
				WuPromotionTypeCollection: [
					{
						Id: 1,
						Text: "Marketing Promotion"
					},
					{
						Id: 2,
						Text: "MyWU Promotion"
					}
				],
				WUSourceOfFundOtherCollection: [
					{
						Id: 1,
						Text: "Charitable Donations"
					},
					{
						Id: 2,
						Text: "Inheritance"
					}
				],
				WUSourceOfFundOtherId: null,
				IsFpxActive: true,
				IsMMPActive: true,
				IsDebitCardActive:true,
				IsStagingActive: true,
				IsStagingResend: false,
				ActiveTab: "fpx",
				MainHeader: "Review Your Payment",
				PaymentCardHeader: "Payment Method",
				IsShowEremitPayMap: false,
				IsShowEremitPayPartnerDetails: false,
				SelectedEremitPayPartner: null,
				mapDetails: {
					Location: null,
					Radius: null,
					MapAddress: null,
					SearchLocation: null
				},
				datalist: [],
				IsResend: false,
				Show10KExceedBanner: false,
				Show5KExceedBanner: false,
				el: -1,
				IsVisaCrossCountry : false,
				VisaDestinationCurrency: null,
				VisaCardIssuerCountry:null,
				VisaDestinationCurrencyId:null,
				visaModalShow: false,
				editVisaModalShow:false,
				visaModalTitle:"",
				errorVisaModal: false,
				errorModal: false,
				IsExchangeRateMismatch: false,
				IsNotEremitCountry: false,
				errorVisaCountryModalShow: false,
				CarryModel:{
					PaymentNetworkId:0,
					CountryId:0,
					PaymentModeId:0,
					PayoutCurrencyId:0,
					SendAmount:0,
					PayAmount:0,
					IsLocalCurrencyKeyIn:false,
					ExchangeRate: 0,
					IsStepOne: false
				},
				PaymentNetworkId: null,
				PromoCode: null
			};
		},
		watch: {
			"vModel.PaymentPurposeId": function (newPP, oldPP) {
				if (newPP != 17) this.vModel.ReasonOfRemittanceOthers = "";
				if (newPP != 10 && newPP != 15) this.vModel.GoodsAndServicesDescription = "";
			},
			"vModel.SourceOfFundId": function (newPP, oldPP) {
				if (newPP != 10) this.vModel.SourceOfFundOthers = "";
			},
			"vModel.SourceOfWealthId": function (newPP, oldPP) {
				if (newPP != 11) this.vModel.SourceOfWealthOthers = "";
			},
			tabIndex: function (newVal, oldVal) {
				this.$nextTick(function () {
					this.setActiveTab();
				});
			},
			"vModel.isOnBehalfTransaction": function (newpp, oldPP) {
				if (!newpp) {
					this.vModel.OnBehalfDetail.OnBehalfCustomerId = null;
					this.vModel.OnBehalfDetail.Name = null;
					this.vModel.OnBehalfDetail.IdNumber = null;
				} else {
					if(this.visaStatus == ''){
						if(!this.vModel.onBehalfDecisionCheck.ShowOnbehalfList) {

							var promises = [];
							promises.push(ListService.getOnBehalfList(this.vModel.PayoutModeId));
							Promise.all(promises).then(resp => {
								this.vModel.OnBehalfList = resp[0].body;
								this.vModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
							})
						}
					}else{
						this.vModel.onBehalfDecisionCheck.ShowOnbehalfList = false;
					}
				}
			}
		},

		methods: {
			handleChangeWuOtherSof(e) {
				var values = this.WUSourceOfFundOtherCollection.map(function (o) {
					return o.Id;
				});
				var index = values.indexOf(this.WUSourceOfFundOtherId);
				this.vModel.SourceOfFundOthers = this.WUSourceOfFundOtherCollection[
					index
				].Text;
			},

			backToStepOne(evt) {
				evt.preventDefault();
				console.log("backtostep");
				if (this.IsShowEremitPayMap) {
					console.log("backtostep set false");
					this.IsShowEremitPayMap = false;
					this.PaymentCardHeader = "Payment Method";
					this.MainHeader = "Review Your Payment";
					this.$nextTick(function () {
						this.activateStagingTab();
					});
					return;
				}
				this.vModel.TransferFee = "0.00";
				this.vModel.ShowGST = false;
				this.visaStatus = "";
				this.vModel.DepositedAmount = parseFloat(this.vModel.PCurrency).toFixed(
					2
				);
				this.stepOne = true;
				return;
			},
			// bindKendo() {
			// 	var kendoPaymentPurpose = this.$refs.kendoPaymentPurpose.kendoWidget();
			// 	kendoPaymentPurpose.setDataSource(this.PaymentPurposeCollection);
			// 	kendoPaymentPurpose.select(this.vModel.PaymentPurposeId);
			// 	var kendoSourceOfFunds = this.$refs.kendoSourceOfFunds.kendoWidget();
			// 	kendoSourceOfFunds.setDataSource(this.SourceOfFundsCollection);
			// 	kendoSourceOfFunds.select(this.vModel.SourceOfFundId);
			// 	if (this.vModel.IsSourceOfWealthNeeded) {
			// 		var kendoSourceOfWealth = this.$refs.kendoSourceOfWealth.kendoWidget();
			// 		kendoSourceOfWealth.setDataSource(this.SourceOfWealthCollection);
			// 		kendoSourceOfWealth.select(this.vModel.SourceOfWealthId);
			// 	}
			// },

			onSubmitOne: function () {
				this.$validator.validateAll().then(result => {
					if (result) {
						if(this.vModel.onBehalfDecisionCheck.ShowOnbehalfSwitch
						  && this.vModel.onBehalfDecisionCheck.DisableOnbehalfSwitch
						  && !this.vModel.OnBehalfDetail.OnBehalfCustomerId){
							  this.$toastr("error", "Please provide the details of the person you're sending on behalf of");
							return false;
						  }
						if (
							!parseFloat(this.vModel.PCurrency) > 0 ||
							!parseFloat(this.vModel.SCurrency) > 0
						) {
							this.$toastr("error", "Please enter amount");
							return false;
						}
						this.onProgress = true;
						this.ValidationType = null;

						if (
							(this.PayoutModeId == "98" || this.PayoutModeId == "97") &&
							this.vModel.WUPromotionType != "" &&
							this.vModel.WUPromotionType != null
						) {
							var promoCode = "";

							if (this.vModel.WUPromotionType == 1) {
								promoCode = this.vModel.WUMarketingPromotionCode;
							} else if (
								this.vModel.IsPromoCodeUsed &&
								this.vModel.WUPromotionType == 2
							) {
								promoCode = this.vModel.PromotionCode;
							} else {
								promoCode = "";
							}
							this.PromoCode = promoCode;
						}

						if (this.PayoutModeId == 22) {
							TransactionService.validateAlipay({
								BeneficiaryId: this.BeneficiaryId,
								PayoutAmount: this.vModel.SCurrency
							}).then(
								res => {
									if (res.body.IsValid) {
										this.vModel.ProcessId = res.body.ProcessId;

										this.$http
											.post("transaction/servicecharge", {
												SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
												PayoutAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
												CountryId: this.vModel.RecipientDetail.CountryId,
												PaymodeId: this.PayoutModeId,
												PromotionCode: promoCode,
												BeneficiaryId: this.BeneficiaryId,
												IsLocalCurrencyKeyedIn: this.vModel
													.IsLocalCurrencyKeyedIn,
												RequestIdentifier: this.vModel.RequestIdentifier,
											    ExchangeRate: this.vModel.ExchangeRate,
												SpecialRateId: (this.vModel.SpecialRateId && this.vModel.LastSpecialRateDialogClickedButton == "YES") ? this.vModel.SpecialRateId : null,
												PromotionCodeId: this.vModel.IsMtaPromotionCodeSelected ? this.vModel.UsedPromocodeDetail.PromotionCodeId : null,
												PromotionDiscount: this.vModel.UsedPromocodeDetail.PromotionDiscount

											})
											.then(
												response => {
													this.vModel.GST = response.body.GST.toFixed(2);
													this.vModel.GSTPercentage = response.body.GSTPercentage;
													this.vModel.TransferFee = response.body.TransferFee.toFixed(
														2

													);
													this.Fee = response.body.TransferFee.toFixed(2);
													this.vModel.DepositedAmount = response.body.DepositedAmount.toFixed(
														2
													);
													this.vModel.PromotionDiscount = response.body.PromotionDiscount.toFixed(
														2
													);
													if (!this.vModel.UsedPromocodeDetail.IsFreeServiceCharge) {
														this.vModel.PromotionDiscount = response.body.PromotionDiscount.toFixed(
														  2
														);
													  } else {
														this.vModel.PromotionDiscount = response.body.TransferFee.toFixed(2);
													  }
													this.vModel.ShowGST = response.body.ShowGST;

													TransactionService.limitCheck({
														SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
														CountryId: this.vModel.RecipientDetail.CountryId,
														Fee: this.Fee,
														GST: this.vModel.GST,
														PaymodeId: this.PayoutModeId,
														PayoutAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
														BeneficiaryId: this.BeneficiaryId
													}).then(
														res => {
															if (res.body.ValidationPassed) {
																this.stepOne = false;
																this.ValidationType = res.body.ValidationType;
																this.LimitMessage = res.body.Message;
															}
															//else {
															//	this.$toastr("warning", res.body.Message);
															//}
															else {
																if (res.body.AllowLimitRequest) {
																	kendo.confirm(
																		res.body.Message +
																		"<br/><br/>Do you want to Increase Limit?"
																	).then(function () {

																		window.Vue.$router.push("/IncreaseLimit");

																	});
																} else {
																	this.$toastr("warning", res.body.Message);
																}
															}
															this.onProgress = false;
														},
														err => {
															this.onProgress = false;
														}
													);
												},
												error => {
													this.onProgress = false;
												}
											);
									} else {
										this.$toastr("error", res.body.Message);
									}
									this.onProgress = false;
								},
								err => {
									this.onProgress = false;
								}
							);
						}
						else if (this.PayoutModeId == 23 && this.vModel.RecipientDetail.CountryId == 1) {
							TransactionService.validateBkashWallet({
								//FirstName: this.vModel.RecipientDetail.FullName,
								//AccountNumber: this.vModel.RecipientDetail.AccountNumber
								BeneficiaryId: this.BeneficiaryId
							}).then(
								res => {
									if (res.body.IsValid) {
										if (res.body.IsNameMatched) {
											this.vModel.ProcessId = res.body.ProcessId;
											this.CalculateServiceCharge();
										}
										else {
											kendo.alert(res.body.Message);
											return false;
										}
									}
								}, err => {
									return false;
								})
						}
						else if (this.PayoutModeId == 27 && this.vModel.RecipientDetail.CountryId == 56) {
							TransactionService.validateWeixinWallet({
								BeneficiaryId: this.BeneficiaryId
							}).then(
								res => {
									if (res.body.IsValid) {
											this.vModel.ProcessId = res.body.ProcessId;
											this.CalculateServiceCharge();
										}
									},
									err => {
									return false;
								})
						}
						else {
							this.CalculateServiceCharge();
						}
					}
				});
			},
			CalculateServiceCharge() {
				this.$http
					.post("transaction/servicecharge", {
						SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
						PayoutAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
						CountryId: this.vModel.RecipientDetail.CountryId,
						PaymodeId: this.PayoutModeId,
						PromotionCode: this.PromoCode,
						BeneficiaryId: this.BeneficiaryId,
						IsLocalCurrencyKeyedIn: this.vModel.IsLocalCurrencyKeyedIn,
						RequestIdentifier: this.vModel.RequestIdentifier,
						ExchangeRate: this.vModel.ExchangeRate,
						SpecialRateId: (this.vModel.SpecialRateId && this.vModel.LastSpecialRateDialogClickedButton == "YES") ? this.vModel.SpecialRateId : null,
						PromotionCodeId: this.vModel.IsMtaPromotionCodeSelected ? this.vModel.UsedPromocodeDetail.PromotionCodeId : null,
						PromotionDiscount: this.vModel.PromotionDiscount
					})
					.then(
						response => {
							if (this.PayoutModeId == 97 || this.PayoutModeId == 98 || this.PayoutModeId == 101 || this.PayoutModeId == 102) {
								this.vModel.PCurrency = response.body.SendAmount.toFixed(2);
								this.vModel.SCurrency = response.body.PayoutAmount.toFixed(
									2
								);
								this.vModel.ExchangeRate = response.body.ExchangeRate;
							}
							this.vModel.GST = response.body.GST.toFixed(2);
							this.vModel.GSTPercentage = response.body.GSTPercentage;
							this.vModel.TransferFee = response.body.TransferFee.toFixed(
								2
							);
							this.Fee = response.body.TransferFee.toFixed(2);
							this.vModel.DepositedAmount = response.body.DepositedAmount.toFixed(
								2
							);
							if (!this.vModel.UsedPromocodeDetail.IsFreeServiceCharge) {
								this.vModel.PromotionDiscount = response.body.PromotionDiscount.toFixed(
									2
								);
							} else {
								this.vModel.PromotionDiscount = response.body.TransferFee.toFixed(2);
							}
							this.vModel.ShowGST = response.body.ShowGST;

							TransactionService.limitCheck({
								SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
								CountryId: this.vModel.RecipientDetail.CountryId,
								Fee: this.Fee,
								GST: this.vModel.GST,
								PaymodeId: this.PayoutModeId,
								PayoutAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
								BeneficiaryId: this.BeneficiaryId
							}).then(
								res => {
									if (res.body.ValidationPassed) {
										//  if(this.PayoutModeId == 101 && this.visaStatus != "01"){
										//  	this.SaveVisaDirectState();
										// 	this.$http.get("transaction/visadirect/create/merchantorderid").then(
										// 		res => {
										// 		window.location.href = "http://localhost:8080/transaction/visa/101/00/" + res.body
										// 		});
										//  }
										//window.location.href =
										if (this.PayoutModeId == 101 && this.visaStatus == "") {
											this.stepOne = true;
											this.ValidationType = res.body.ValidationType;
											this.LimitMessage = res.body.Message;
											TransactionService.visaCardInquiry({
												SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
												PayoutCountryId: this.vModel.RecipientDetail.CountryId,
												ReceiverCurrency: this.vModel.PayCurrency,
												PaymodeId: this.PayoutModeId,
												ReceiveAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
												BeneficiaryId: this.BeneficiaryId,
												RequestIdentifier: this.vModel.RequestIdentifier
											}).then(
												res => {
													this.SaveVisaDirectState();
													if (res.body.RedirectUrl) {
														window.location.href = res.body.RedirectUrl;
														return;
													}
													var visaDirect = document.querySelector(".visaDirectWrapper");
													visaDirect.innerHTML = res.body.Body;
													var f = visaDirect.querySelector("#visaPayment");
													f.submit();
												},
												err => {
													this.onProgress = false;
												}
											);
										} else {
											this.stepOne = false;
											this.ValidationType = res.body.ValidationType;
											this.LimitMessage = res.body.Message;
										}

									}
									//else {
									//	this.$toastr("warning", res.body.Message);
									//}
									else {
										if (res.body.AllowLimitRequest) {
											kendo.confirm(
												res.body.Message +
												"<br/><br/>Do you want to Increase Limit?"
											).then(function () {

												window.Vue.$router.push("/IncreaseLimit");

											});
										} else {
											this.$toastr("warning", res.body.Message);
										}
									}
									this.onProgress = false;
								},
								err => {
									this.onProgress = false;
								}
							);
						},
						error => {
							this.onProgress = false;
						}
					);
			},
			onPostTransaction() {
				var params = {
					BeneficiaryId: this.BeneficiaryId,
					PaymodeId: this.PayoutModeId,
					SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
					PayoutAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
					SourceOfFundId: this.vModel.SourceOfFundId,
					PaymentPurposeId: this.vModel.PaymentPurposeId,
					Fee: this.vModel.TransferFee,
					ExchangeRate: this.vModel.ExchangeRate,
					CountryId: this.vModel.RecipientDetail.CountryId,
					ReasonOfRemittanceOthers: this.vModel.ReasonOfRemittanceOthers,
					SourceOfFundOthers: this.vModel.SourceOfFundOthers,
					SourceOfWealthId: this.vModel.SourceOfWealthId,
					SourceOfWealthOthers: this.vModel.SourceOfWealthOthers,
					OrbitPaymentReference: this.vModel.OrbitPaymentReference,
					GST: this.vModel.GST,
					BonuslinkCardNumber: this.vModel.BonuslinkCardNumber,
					IsNegative: this.vModel.IsNegative,
					IsPEPS: this.vModel.IsPEPS,
					IsHRI: this.vModel.IsHRI,
					IsHRC: this.vModel.IsHRC,
					Ramount: false,
					SenderBankCode: "",
					PaymentMethod:
						this.ActiveTab == "fpx" ? 1 : this.ActiveTab == "mmp" ? 2 : this.ActiveTab == "ipay88" ? 6 : 4,
					BankId: this.ActiveTab == "fpx" ? this.vModel.FPXBankId : null,
					DebitCardId: this.ActiveTab == "ipay88" ? this.vModel.DebitCardId : null,
					IsIPAY88DebitCardSave : this.ActiveTab == "ipay88" ?  this.vModel.IsIPAY88DebitCardSave : null,
					MMPayUserName:
						this.ActiveTab == "mmp" ? this.vModel.MMPayUserName : null,
					WUPromotionType: null,
					WUPromotionCode: "",
					GalacticId: this.vModel.GalacticId,
					IsLocalCurrencyKeyedIn: this.vModel.IsLocalCurrencyKeyedIn,
					Question:
						this.vModel.RecipientDetail.CountryId == 220
							? this.vModel.Question
							: null,
					Answer:
						this.vModel.RecipientDetail.CountryId == 220
							? this.vModel.Answer
							: null,
					RequestIdentifier: this.vModel.RequestIdentifier,
					TransactionRefNo: commonService.getStorage("transactionRefNo"),
					IsResend: this.IsResend,
					ProcessId: this.vModel.ProcessId,
					GoodsAndServicesDescription: this.vModel.GoodsAndServicesDescription,
					DefaultRate: this.vModel.DefaultRate,
				    SpecialRateId: (this.vModel.SpecialRateId && this.vModel.LastSpecialRateDialogClickedButton == "YES") ? this.vModel.SpecialRateId : null,
				    IsSpecialRate: (this.vModel.SpecialRateId && this.vModel.LastSpecialRateDialogClickedButton == "YES") ? true : false,
				    PromotionCodeId: this.vModel.IsMtaPromotionCodeSelected ? this.vModel.UsedPromocodeDetail.PromotionCodeId : null,
				    PromotionDiscount: this.vModel.PromotionDiscount,
				    IsFreeServiceCharge: this.vModel.IsMtaPromotionCodeSelected ? this.vModel.UsedPromocodeDetail.IsFreeServiceCharge : false,
					OnBehalfCustomerId: this.vModel.OnBehalfDetail.OnBehalfCustomerId,
					OrderReference : this.vModel.OrderReference,
					InquiryOrderId: this.vModel.InquiryOrderId,
					VisaCardNumber: this.vModel.VisaCardNumber,
					VisaCardIssuerCountry: this.vModel.VisaCardIssuerCountry
				};
				if (
					(this.PayoutModeId == "98" || this.PayoutModeId == "97") &&
					this.vModel.WUPromotionType != "" &&
					this.vModel.WUPromotionType != null
				) {
					var promoCode = "";

					if (this.vModel.WUPromotionType == 1) {
						promoCode = this.vModel.WUMarketingPromotionCode;
					} else if (
						this.vModel.IsPromoCodeUsed &&
						this.vModel.WUPromotionType == 2
					) {
						promoCode = this.vModel.PromotionCode;
					} else {
						promoCode = "";
					}

					params.WUPromotionType =
						promoCode == "" ? null : this.vModel.WUPromotionType;
					params.WUPromotionCode = promoCode;
				}
				if (this.vModel.IsDocumentRefNoRequired) {
					params.DocumentRefNumber = this.vModel.DocumentRefNo;
				}
				TransactionService.post(params).then(
					res => {
						commonService.setStorage(
							"transactionRefNo",
							res.body.TransactionRefNo
						);

						if (params.PaymentMethod == 2) {
							commonService.setStorage(
								"mmpayUserName",
								this.vModel.MMPayUserName
							);
							commonService.setStorage(
								"AuthMode",
								res.body.AuthMode
							);
						}
						if (res.body.Body == "EKYC")
							this.$router.push("/transaction/ekycotp");
						else {
							if (params.PaymentMethod == 2) {
								if (res.body.AuthMode == "NoAuth") {
									this.vModel = {
										TransactionRefNumber: res.body.TransactionRefNo,
										OTP: null
									};
									this.$http.post(this.url.submitnoOTP, this.vModel).then(
										response => {
											commonService.setStorage("transactionRefNo", "");
											this.isProcessing = false;
											this.$router.push("/transaction/confirmation/" + res.body.TransactionRefNo);
										}
									);
									//this.$router.push(
									//	"/transaction/confirmation/" + res.body.TransactionRefNo);
								} else {
									this.$router.push("/transaction/otp");
								}
							} else if (params.PaymentMethod == 4) {
								this.$router.push(
									"/transaction/confirmation/" + res.body.TransactionRefNo
								);
							} else if (params.PaymentMethod == 6) {
								var ipay88 = document.querySelector(".ipay88Wrapper");
								ipay88.innerHTML = res.body.Body;
								var f = ipay88.querySelector("#ePayment");
								f.submit();
							} else {
								var fpx = document.querySelector(".fpxWrapper");
								fpx.innerHTML = res.body.Body;
								var f = fpx.querySelector("#bankpaymentform");
								f.submit();
							}
						}
					},
					err => {
						console.log(err);
						console.log(err.message);
						this.onProgress = false;
					}
				);
			},
			onSubmit: function () {
				if (this.IsShowEremitPayMap) {
					this.IsShowEremitPayMap = false;
					this.$nextTick(function () {
						this.activateStagingTab();
					});
					return;
				}
				if (this.onProgress) return false;
				if (!this.stepOne) {
					if (this.ActiveTab == "fpx" && this.errors.has("FpxTermandCondition")) {
						kendo.alert(
							"Please confirm if you have read and agreed to Merchantrade Asia Sdn Bhd's Term & Condition and Privacy Notice"
						);
						return false;
					} else if (
						this.ActiveTab == "mmp" &&
						this.errors.has("MMPTermandCondition")
					) {
						kendo.alert(
							"Please confirm if you have read and agreed to Merchantrade Asia Sdn Bhd's Term & Condition and Privacy Notice"
						);
						return false;
					} else if (
						this.ActiveTab == "Staging" &&
						this.errors.has("StagingTermsandCondition")
					) {
						kendo.alert(
							"Please confirm if you have read and agreed to Merchantrade Asia Sdn Bhd's Term & Condition and Privacy Notice"
						);
						return false;
					} else if(
						this.ActiveTab == "ipay88" &&
						this.errors.has("IPAY88TermandCondition")
					) {
						kendo.alert(
							"Please confirm if you have read and agreed to Merchantrade Asia Sdn Bhd's Term & Condition and Privacy Notice"
						);
					}
				}

				this.$validator.validateAll().then(resultStepOne => {
					if (resultStepOne) {
						this.onProgress = true;
						//Check for MMP 10K Plus Transaction
						if ((parseFloat(this.vModel.DepositedAmount)) >= 10000 && this.ActiveTab == "mmp") {
							console.log("Hello I'm in 10K");
							this.Show10KExceedBanner = true;
							this.onProgress = false;
						}else if ((parseFloat(this.vModel.DepositedAmount)) >= 5000 && this.ActiveTab == "ipay88"){
							console.log(this.ActiveTab, this.vModel.DepositedAmount, "Hello I'm in 5K")
							this.Show5KExceedBanner = true;
							this.onProgress = false;
						}
						else {
							this.onPostTransaction();
						}
					}
				});
			},

			onCancel: function (evt) {
				evt.preventDefault();
				if (this.IsResend) this.$router.push("/transaction");
				else this.$router.push("/recipient");
			},
			setActiveTab: function () {
				var fpxTab = document.getElementById("tabfpx");
				var ipay88tab = document.getElementById("tabipay88");

				var mmpTab = document.getElementById("tabMMP");
				var stagingTab = document.getElementById("tabStaging");
				if (mmpTab != null && mmpTab.classList.contains("active"))
					this.ActiveTab = "mmp";
				else if (stagingTab != null && stagingTab.classList.contains("active"))
					this.ActiveTab = "Staging";
				else if (ipay88tab !=null && ipay88tab.classList.contains("active")){
					this.ActiveTab = "ipay88"
				}
				else this.ActiveTab = "fpx";
			},
			activateStagingTab: function () {
				var stagingTab = document.getElementById("tabStaging");
				// fpxTab.classList.remove('active');
				// stagingTab.classList.add('active');
				stagingTab.click();
			},
			showEremitMap: function () {
				console.log(this.IsShowEremitPayMap);
				this.IsShowEremitPayMap = true;
				this.MainHeader = "Find Partners";
				this.PaymentCardHeader = "Find eRemitPay Partners Locations";
			},
			afterOkHandled(value) {
				this.Show10KExceedBanner = value;
			},
			afterOkDebitCardHandled(value) {
				this.Show5KExceedBanner = value;
			},
			getPromocodeList: function () {
				this.vModel.SearchedPromocode = null;
				this.$http
				  .post("v2/transaction/promocodelist", {
					PaymentNetworkId: this.vModel.PayoutModeId == 101 || this.vModel.PayoutModeId == 102 ? 3 : 1,
					RecipientId: this.vModel.RecipientDetail.Id,
					PaymentModeId: this.vModel.PayoutModeId,
				  })
				  .then(
					(response) => {
					  this.vModel.PromocodeDetailList = response.body;
					  this.vModel.ShowPromocodeDialog = true;

					},

				  );

			},
			onPromocodeCancel() {
				this.vModel.IsMtaPromotionCodeSelected = false;
				this.vModel.PromotionDiscount = null;
				this.vModel.SearchedPromocode = null;

				this.vModel.UsedPromocodeDetail.PromotionCodeId = null,
				  this.vModel.UsedPromocodeDetail.PromotionDiscount = null,
				  this.vModel.UsedPromocodeDetail.IsFreeServiceCharge = null,
				  this.vModel.UsedPromocodeDetail.ValidityDateFrom = null,
				  this.vModel.UsedPromocodeDetail.PromoCode = null,
				  this.vModel.UsedPromocodeDetail.TotalPromocodesAvailable = null,
				  this.vModel.UsedPromocodeDetail.TotalPromocodesUsed = null,
				  this.vModel.UsedPromocodeDetail.ValidityDateTo = null

			},
			onRemoveOnBehalfCustomer: function () {
				this.vModel.OnBehalfDetail.OnBehalfCustomerId = null;
				this.vModel.OnBehalfDetail.Name = null;
				this.vModel.OnBehalfDetail.IdNumber = null;
				this.vModel.isOnBehalfTransaction = false;
			},
			confirmSaveDebitCard: function () {
				var self = this;
				var ipay88tab = document.getElementById("tabipay88");
				var agreeTerms = document.getElementById("IPAY88TermandCondition");
				if(self.ActiveTab !=null && ipay88tab.classList.contains("active") && !agreeTerms.checked){
						kendo.alert(
					 	"Please confirm if you have read and agreed to Merchantrade Asia Sdn Bhd's Term & Condition and Privacy Notice"
						);
						return;
				}
				this.el=-1;
				if(self.NoOfCardPerCustomer == self.IPAY88DebitCardCollection.length){
						kendo.alert("Maximum no. of card reached.")
						return;
					}
				kendo.confirm("Would you like to save this card for any future transactions?").then(function () {
					self.vModel.IsIPAY88DebitCardSave = true;
					self.vModel.DebitCardId = null;
					this.visaModalShow = false;
					this.editVisaModalShow = false;
					self.onSubmitOne();
					self.onSubmit();
				}, function () {
					self.vModel.IsIPAY88DebitCardSave = false;
					this.visaModalShow = false;
					this.editVisaModalShow = false;
					self.onSubmitOne();
					self.onSubmit();
				});
			},
			selectDebitCard: function (id) {
				this.vModel.DebitCardId = id;
				this.el = id;
				this.vModel.IsIPAY88DebitCardSave = false;
			},
			deleteDebitCard: function(cardId, index){
				var self = this;
				kendo.confirm("Are you sure to delete selected debit card!").then(function() {
			 self.$http
				  .post("account/ipay88/deletedebitcard", {
					Id: cardId,
				  })
				  .then(
					(response) => {
					  var res = response.body;
					  if(res.Success == true){
						  self.IPAY88DebitCardCollection.splice(index,1);
						  kendo.alert(res.ResponseMessage);
					  }else{
						  kendo.alert("Sorry, your Debit Card was not deleted due to some errors.")
					  }
					},

				  );
				})
		 	},
			SaveVisaDirectState: function(){
				commonService.setStorage("visaModel", this.vModel);
				commonService.setStorage("RequestIdentifier", this.vModel.RequestIdentifier);
				commonService.setStorage("visaBeneficiaryId", this.BeneficiaryId);
				commonService.setStorage("PayoutModeId", this.PayoutModeId);
				commonService.setStorage("PayoutModeText", this.PayoutModeText);
				commonService.setStorage("isInit", this.isInit);
				commonService.setStorage("PaymentPurposeCollection", this.PaymentPurposeCollection);
				commonService.setStorage("SourceOfFundsCollection", this.PaymentPurposeCollection);
				commonService.setStorage("SourceOfWealthCollection", this.PaymentPurposeCollection);
				commonService.setStorage("IsResend", this.IsResend);
				commonService.setStorage("Fee", this.Fee);
			},
			SetVisaDirectState: function(){
				this.vModel = commonService.getStorage("visaModel");
				this.BeneficiaryId = commonService.getStorage("visaBeneficiaryId");
				this.PayoutModeId = commonService.getStorage("PayoutModeId");
				this.PayoutModeText = commonService.getStorage("PayoutModeText");
				this.isInit = commonService.getStorage("isInit");
				this.PaymentPurposeCollection = commonService.getStorage("PaymentPurposeCollection");
				this.PaymentPurposeCollection = commonService.getStorage("SourceOfFundsCollection");
				this.PaymentPurposeCollection = commonService.getStorage("SourceOfWealthCollection");
				this.IsResend = commonService.getStorage("IsResend");
				this.Fee = commonService.getStorage("Fee");
			},
			ClearVisaStorage: function(){
				commonService.removeStorage("visaModel", this.vModel);
				commonService.removeStorage("PayoutModeText", this.PayoutModeText);
				commonService.removeStorage("PayoutModeId", this.PayoutModeId);
				commonService.removeStorage("isInit", this.isInit);
				commonService.removeStorage("PaymentPurposeCollection", this.PaymentPurposeCollection);
				commonService.removeStorage("SourceOfFundsCollection", this.PaymentPurposeCollection);
				commonService.removeStorage("SourceOfWealthCollection", this.PaymentPurposeCollection);
				commonService.removeStorage("IsResend", this.IsResend);
				commonService.removeStorage("Fee", this.Fee);
			},
			SaveVisaBeneAndSubmitOne : function(){
				// if(this.vModel.visaStatus == "00"){
				// 	this.onSubmitOne();
				// }else{
					TransactionService.saveVisaBeneOnCurrencyMismatch({
						RequestIdentifier: this.vModel.RequestIdentifier,
						CountryId: this.vModel.RecipientDetail.CountryId,
						CurrencyId: this.VisaDestinationCurrencyId,
						VisaCardNumber: this.vModel.VisaCardNumber,
						BeneficiaryId: this.BeneficiaryId,
						SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
						PayoutAmount: parseFloat(this.vModel.SCurrency).toFixed(2),
						ExchangeRate: this.vModel.ExchangeRate,
						CardIssuerCountry: this.vModel.VisaCardIssuerCountry,
					}).then(
						res => {
							if(res.status == 200){
								this.visaModalShow = false;
								this.editVisaModalShow = false;
								this.onSubmitOne();
							}else{
								console.log(res);
							}
						}
					)
			},
			ShowVisaPopUpEdit: function(){
				this.visaModalShow = false;
				this.editVisaModalShow = true;
			},
			OnVisaCancel: function(){
				this.$router.push("/recipient");
			}
		}
	};
</script>

<style scoped>
	ul.fraudMessage {
		margin-left: 40px;
		padding: 10px 0;
	}

	ul.fraudMessage li {
		list-style: inherit;
	}

	.rounded-div {
		border-radius: 100%;
		background: #c21c2b;
		padding: 8px;
		width: 40px;
		height: 40px;
		text-align: center;
		color: white;
	}

	.findLocationsBtn {
		border-radius: 8px;
		background-color: #ffc000;
		color: white;
		widows: 50%;
	}

	.debit-card{
		padding: 0 2%;
	}

	.debit-card .row{
		border-radius: 10px;
   		/* background-color: lightgray; */
	}

	.debit-card .col-md-1 ,.debit-card .col-md-2 , .debit-card .col-md-9, .add-card {
		cursor: pointer;
	}
	.debit-card .col-md-1{
    	padding-top: 1%;
	}
	.debit-card .col-md-1 :hover{
		color: red;
	}

	.rounded-border{
		padding: 1%;
		border: 1px solid lightgray;
		border-radius: 10px;
	}

	.add-card{
		cursor:pointer;
	}

	.debit-card:hover,.debit-card:focus {
		background-color: lightgray;
		 border: 0px solid lightgray;
		border-radius: 10px;
	}

	.scselect {
		background-color: lightgray;
		border: 0px solid lightgray;
		border-radius: 10px;
	}

	.debit-card .col-md-2{
		padding-top: 5px;
	}

	#crossCountryModal .row{
		margin: 0 70px;
	}

    #editVisaAmountModal .modal-content{
		width: 40em !important;
	}

	.editTitle{
		text-align: center;
		padding-left: 16em;
	}
</style>
